
import { FaMapMarkerAlt, FaClock, FaUserMd,FaBrain,FaHeartbeat,FaMoon,FaTint,FaLeaf,FaMedkit,FaRegHeart,FaCapsules,FaSyringe,FaRegClock,FaBaby,FaCalendarCheck,FaCompress, FaSpa,FaBalanceScale,FaBolt,FaShieldAlt,FaFireExtinguisher,FaRegCircle,FaUtensils,FaAllergies,FaRegSmile,FaSun,FaSkullCrossbones,FaBug} from 'react-icons/fa';
import eczema from './../../../assets/images/eczemabanner.png';
import eczematreatment from './../../../assets/images/eczemaappointment.png';
import eczemagallery1 from './../../../assets/images/eczema.jpg';
import eczemagallery2 from './../../../assets/images/eczemagallery2.png';
import eczemagallery3 from './../../../assets/images/eczemagallery2.png';
import eczemagallery4 from './../../../assets/images/eczemagallery4.png'; 

//disease psoriasis
import bestpsoriasis from './../../../assets/images/best psoriasis treatment banner.png'
import Psoriasis1 from './../../../assets/images/Psoriasis.jpg';
import Psoriasis12 from './../../../assets/images/Psoriasis-Treatment-in-Homeopathy..jpg';
import Psoriasis2 from './../../../assets/images/scalp-psoriasis-treatment.jpg';
import Psoriasis3 from './../../../assets/images/psoriasis on body Treatment.png';
import Psoriasistreatment from './../../../assets/images/Psoriasistreatment.jpg'

// disease Asthma
import AsthmaBanner from './../../../assets/images/asthmabanner.png';
import Asthma1 from './../../../assets/images/asthmatreatment1.png';
import Asthma2 from './../../../assets/images/asthmatreatment2.png';
import Asthma3 from './../../../assets/images/asthmatreatment3.png';
import Asthma4 from './../../../assets/images/asthmatreatment4.png';

//disease diabetes
import diabetesBanner from './../../../assets/images/diabetesbanner.png';
import diabetes1 from './../../../assets/images/asthmatreatment1.png';
import diabetes2 from './../../../assets/images/asthmatreatment2.png';
import diabetes3 from './../../../assets/images/asthmatreatment3.png';
import diabetes4 from './../../../assets/images/asthmatreatment4.png';
import diabetesappointment from './../../../assets/images/diabetesappointment.png'

//disease diabetes
import migranebanner from './../../../assets/images/migranebanner.png';
import migrane1 from './../../../assets/images/asthmatreatment1.png';
import migrane2 from './../../../assets/images/asthmatreatment2.png';
import migrane3  from './../../../assets/images/asthmatreatment3.png';
import migrane4 from './../../../assets/images/asthmatreatment4.png';
import migranappointment from './../../../assets/images/migraneappointment.jpg'


//alopecia
import alopecia from './../../../assets/images/alopecia treatment banner.png';
import alopecia1 from './../../../assets/images/alopecia1.png';
import alopecia2 from './../../../assets/images/alopecia2.png';
import alopecia3  from './../../../assets/images/alopecia3.png';
import alopecia4 from './../../../assets/images/alopecia4.png';
import alopeciatreatment from './../../../assets/images/alopeciabookappointment.png'
  

//"PCOD/PCOS
import pcodpcos from './../../../assets/images/pcodpcostreatment.png';
import  pcodgallery1 from './../../../assets/images/asthmatreatment1.png';
import pcodgallery2 from './../../../assets/images/asthmatreatment2.png';
import pcodgallery3 from './../../../assets/images/asthmatreatment3.png';
import pcodgallery4 from './../../../assets/images/asthmatreatment4.png';
import pcodtreatment from './../../../assets/images/pcod and pcos appointment.png'

//irritable
import ibs from './../../../assets/images/irratabelbanner.png';
import ibs1 from './../../../assets/images/asthmatreatment1.png';
import ibs2 from './../../../assets/images/asthmatreatment2.png';
import ibs3 from './../../../assets/images/asthmatreatment3.png';
import ibs4 from './../../../assets/images/asthmatreatment4.png';
import ibstreatment from './../../../assets/images/irritable bowlsyndrromebook appointement.png'

//hairfall
import hairfall from './../../../assets/images/best hair fall treatment banner.png';
import hairfallgallery1 from './../../../assets/images/asthmatreatment1.png';
import hairfallgallery2 from './../../../assets/images/asthmatreatment2.png';
import hairfallgallery3 from './../../../assets/images/asthmatreatment3.png';
import hairfallgallery4 from './../../../assets/images/asthmatreatment4.png';
import hairfalltreatment from './../../../assets/images/hair faal treatment book appointment.png'

//anxiety

import anxietyBanner from './../../../assets/images/best Anxiety Neurosis treatment banner.png';
import anxietyGallery1 from './../../../assets/images/asthmatreatment1.png';
import anxietyGallery2 from './../../../assets/images/asthmatreatment2.png';
import anxietyGallery3 from './../../../assets/images/asthmatreatment3.png';
import anxietyGallery4 from './../../../assets/images/asthmatreatment4.png';
import anxietyTreatment from './../../../assets/images/Anxiety Neurosis treatment.png'


//prostatitis

import prostatitisBanner  from './../../../assets/images/best Prostatitis treatment.png';
import prostatitisGallery1 from './../../../assets/images/asthmatreatment1.png';
import prostatitisGallery2 from './../../../assets/images/asthmatreatment2.png';
import prostatitisGallery3 from './../../../assets/images/asthmatreatment3.png';
import prostatitisGallery4 from './../../../assets/images/asthmatreatment4.png';
import prostatitisTreatment from './../../../assets/images/Prostatitis treatment.png'


//sleeplessness
import sleeplessnessBanner from './../../../assets/images/Sleeplessness problem treatment.png';
import sleeplessnessGallery1 from './../../../assets/images/asthmatreatment1.png';
import sleeplessnessGallery2 from './../../../assets/images/asthmatreatment2.png';
import sleeplessnessGallery3 from './../../../assets/images/asthmatreatment3.png';
import sleeplessnessGallery4 from './../../../assets/images/asthmatreatment4.png';
import insomniaTreatment from './../../../assets/images/best Sleeplessness treatments.png'

//collities
import colitisBanner from './../../../assets/images/Ulcerative Colitis.png';
import colitisGallery1 from './../../../assets/images/asthmatreatment1.png';
import colitisGallery2 from './../../../assets/images/asthmatreatment2.png';
import colitisGallery3 from './../../../assets/images/asthmatreatment3.png';
import colitisGallery4 from './../../../assets/images/asthmatreatment4.png';
import colitisTreatment from './../../../assets/images/ulcerative coltitis treatment.png'

//piles
import pilesBanner from './../../../assets/images/piles treatment.png';
import pilesGallery1 from './../../../assets/images/asthmatreatment1.png';
import pilesGallery2 from './../../../assets/images/asthmatreatment2.png';
import pilesGallery3 from './../../../assets/images/asthmatreatment3.png';
import pilesGallery4 from './../../../assets/images/asthmatreatment4.png';
import pilesTreatment from './../../../assets/images/best piles treatment.png'

//infertility
import infertilityBanner from './../../../assets/images/Infertility treatments.png';
import infertilityGallery1 from './../../../assets/images/asthmatreatment1.png';
import infertilityGallery2 from './../../../assets/images/asthmatreatment2.png';
import infertilityGallery3 from './../../../assets/images/asthmatreatment3.png';
import infertilityGallery4 from './../../../assets/images/asthmatreatment4.png';
import infertilityTreatment from './../../../assets/images/best Infertility treatment.png'

//varicose

import varicoseBanner from './../../../assets/images/best Varicose treatment.png';
import varicoseGallery1 from './../../../assets/images/asthmatreatment1.png';
import varicoseGallery2 from './../../../assets/images/asthmatreatment2.png';
import varicoseGallery3 from './../../../assets/images/asthmatreatment3.png';
import varicoseGallery4 from './../../../assets/images/asthmatreatment4.png';
import varicoseTreatment from './../../../assets/images/Varicose treatment.png'

//thyroid

import thyroidBanner from './../../../assets/images/Thyroid treatment.png';
import thyroidGallery1 from './../../../assets/images/asthmatreatment1.png';
import thyroidGallery2 from './../../../assets/images/asthmatreatment2.png';
import thyroidGallery3 from './../../../assets/images/asthmatreatment3.png';
import thyroidGallery4 from './../../../assets/images/asthmatreatment4.png';
import thyroidTreatment from './../../../assets/images/best Thyroid treatment.png'

//gerd
import gerdBanner from './../../../assets/images/Gerd treatment.png';
import gerdGallery1 from './../../../assets/images/asthmatreatment1.png';
import gerdGallery2 from './../../../assets/images/asthmatreatment2.png';
import gerdGallery3 from './../../../assets/images/asthmatreatment3.png';
import gerdGallery4 from './../../../assets/images/asthmatreatment4.png';
import gerdTreatment from './../../../assets/images/best Gerd treatment.png'

//melanoma
import melanoma from './../../../assets/images/melanoma banner 1.png';
import melanoma1 from './../../../assets/images/asthmatreatment1.png';
import melanoma2 from './../../../assets/images/asthmatreatment2.png';
import melanoma3 from './../../../assets/images/asthmatreatment3.png';
import melanoma4 from './../../../assets/images/asthmatreatment4.png';
import melanomatreatment from './../../../assets/images/melanoma book 1.png';

//acne
import acne from './../../../assets/images/acne banner 1.png';
import acnegallery1 from './../../../assets/images/asthmatreatment1.png';
import acnegallery2 from './../../../assets/images/asthmatreatment2.png';
import acnegallery3 from './../../../assets/images/asthmatreatment3.png';
import acnegallery4 from './../../../assets/images/asthmatreatment4.png';
import acnetreatment from './../../../assets/images/acne book 1.png';

//dermtities
import dermatitis from './../../../assets/images/Dermatitis banner 1.png';
import dermatitis1 from './../../../assets/images/asthmatreatment1.png';
import dermatitis2 from './../../../assets/images/asthmatreatment2.png';
import dermatitis3 from './../../../assets/images/asthmatreatment3.png';
import dermatitis4 from './../../../assets/images/asthmatreatment4.png';
import dermatitistreatment from './../../../assets/images/Dermatitis book 1.png';

//vitiligo
import vitiligo from './../../../assets/images/vitiligo banner 1.png';
import vitiligogallery1 from './../../../assets/images/asthmatreatment1.png';
import vitiligogallery2 from './../../../assets/images/asthmatreatment2.png';
import vitiligogallery3 from './../../../assets/images/asthmatreatment3.png';
import vitiligogallery4 from './../../../assets/images/asthmatreatment4.png';
import vitiligotreatment from './../../../assets/images/vitiligo book 1.png';

//scabbies 
import scabies from './../../../assets/images/Scabies banner 1.png';
import scabies1 from './../../../assets/images/asthmatreatment1.png';
import scabies2 from './../../../assets/images/asthmatreatment2.png';
import scabies3 from './../../../assets/images/asthmatreatment3.png';
import scabies4 from './../../../assets/images/asthmatreatment4.png';
import scabiestreatment from './../../../assets/images/Scabies book 1.png';


export const diseaseData = [
// eczema
  {
        id: "eczema",
        name: "eczema",
        metadata:[
          {
          title: "Eczema Treatment | H-Cura Homeopathy",
          description: "Get expert homeopathy treatment for eczema at H-Cura Homeopathy. Book your consultation today for safe and effective care.",
          keywords: "Eczema treatment, Homeopathy for eczema, H-Cura Homeopathy, Best homeopathy clinic for skin diseases",
          canonicalUrl: "https://www.h-cura.com/treatments/eczema",
          favicon: "/assets/images/favicon.ico"
          }
        ],
        content: [
            { type: "heading", content: "Best Homeopathic Eczema Treatment" },
        ],
        content1: [
            {
                type: "image",
                src: eczema,
                alt: "eczema-image1",
                className: "treatment-banner",
            },
            {
                type: "text",
                content: "Eczema Treatment",
                className: "treatment-text",
            },
            {
                type: "link",
                to: "/bookconsultation",
                buttonText: "Book Appointment",
                className: "book-appointment-button",
            },
        ],
        content2:[
            
                { type: "heading", content: "Best Homeopathic Eczema Treatment" },
            
        ],

        content3: [
            
            {
                type: "heading",
                content: "Eczema: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
                className: "treatmentprecautions",
            },
            {
                type: "subheading",
                content: "Understanding Eczema",
                className: "treatmentprecautions",
            },
            {
                type: "paragraph",
                content: "Eczema is a chronic skin condition that manifests as red, itchy, and inflamed skin. This condition can affect individuals of any age and may occur on various body parts such as the face, neck, hands, and feet. The severity of eczema can range from mild irritation to severe cases that significantly impact daily life. Eczema on the face often leads to visible distress and emotional challenges, as it can impact one's self-esteem. Dyshidrotic eczema often causes blisters and intense itching on the hands and feet, which can severely affect daily activities.",
                className: "treatmentprecautions",
            },
        ],

        content4:[
           
            {
              type: "list",
              content: "Causes of Eczema",
              className: "treatmentinfection1",
              items: [
                "Genetic Factors: A family history of eczema or allergies increases the risk of developing eczema.",
                "Environmental Factors: Temperature, humidity changes, and pollution can worsen eczema symptoms.",
                "Allergens: Dust, pet dander, and certain foods like dairy and nuts trigger eczema flare-ups.",
                "Stress: Stress can lead to worsening eczema symptoms or outbreaks.",
                "Other Autoimmune Disorders: Harsh soaps and skin irritants aggravate eczema symptoms."
              ],
             
            },
            {
              type: "image-overlay",
              src: eczematreatment, // Replace with your actual image path
              alt: "Eczema Treatment Image",
              title: "Book an Appointment",
              description: "Effective solutions to smooth and heal your skin.",
              link: "/bookconsultation",
              buttonText: "Book Appointment",
              
            }
          ],
        content5:[
           
              {
                type: "list",
                content: "Complications of Eczema",
                items: [
                  "Bacterial and fungal infections: Scratching open the skin can allow bacteria to enter, leading to infections.",
                  "Permanent skin thickening or scarring: Chronic scratching and inflammation can cause the skin to become leathery and thickened.",
                  "Sleep disturbances: The constant itching can affect your ability to sleep, leading to fatigue and irritability."
                ],
               
              },
              {
                type: "list1",
                content: "Symptoms of Eczema",
                content1: "Eczema symptoms vary widely and depend on the type and severity of the condition. Typical symptoms include persistent itching, red or inflamed skin, dry and scaly patches, oozing sores, and skin thickening in chronic cases.",
                items: [
                  "Persistent itching is often the most bothersome symptom of eczema, leading to scratching and skin damage.",
                  "Red, inflamed skin may appear pink, red, or darker in certain individuals, causing irritation.",
                  "Dry, cracked skin becomes extremely dry and can crack, causing discomfort and potential damage."
                ],
                
              }
            
        ],

        content6:[
            {
              type: "paragraph",
              content: "Diagnosis of Eczema",
              content1:
                "At H-Cura Homeopathy, we adopt a comprehensive approach to diagnosing eczema. This involves a detailed medical history review, physical examination, and identification of specific triggers. A detailed medical history review plays a crucial role in identifying genetic and environmental factors that contribute to eczema. It helps to understand the patient’s family history, past health conditions, and potential allergens A physical examination of the skin is essential to assess its characteristics and distinguish between different types of eczema. By carefully examining the skin, a healthcare provider can determine the severity and type of eczema, which is vital for effective treatment Additionally, identifying triggers such as environmental stress, diet, or exposure to specific substances allows for the development of a personalized treatment plan tailored to the patient’s unique needs. This comprehensive approach ensures a more accurate diagnosis and targeted therapy for managing eczema.",
              className: "treatmentDiagnosis"
            },
            
          ],

         content7:[
            
                { src: eczemagallery1, alt: "eczema" },
                { src: eczemagallery2, alt: "eczema" },
                { src: eczemagallery3, alt: "eczema" },
                { src: eczemagallery4, alt: "eczema" }
              
         ],
         content8:[
              {
                title1: "Homeopathic Treatment for Eczema at H-Cura",
                description1:
                  "Our homeopathic treatments focus on addressing the root causes of eczema and promoting long-term healing. By strengthening the immune system and minimizing dependence on conventional medications, our remedies are safe and effective.",
               }],
              content9:[   {
                  icon: <FaMapMarkerAlt className="feature-icon1" />,
                  title: "Strengthen the immune system",
                  description: "We focus on rebalancing the immune system to prevent flare-ups."
                },
                {
                  icon: <FaUserMd className="feature-icon1" />,
                  title: "Promote skin health",
                  description: "Our remedies work on restoring the skin’s natural barrier and preventing dryness, itching, and irritation."
                },
                {
                  icon: <FaClock className="feature-icon1" />,
                  title: "Personalized Follow-Ups",
                  description: "Regular monitoring and adjustments ensure the best results."
                }
              ],
              content10:[
                {
                  title: "Why Choose H-Cura Homeopathy for Eczema Treatment?",
                },
              ],
              content11:[
                {
                  description:
                    "Our treatment addresses the root causes of eczema and emphasizes overall health and wellness.",
                },
                {
                  description:
                    "With years of experience in treating eczema, our practitioners provide expert care for optimal healing.",
                },
                {
                  description:
                    "We focus on patient-centric care, developing personalized treatment plans based on each patient's symptoms and lifestyle.",
                },

              ],
            content12:[
              
                {
                  title: "Effective Management of Eczema",
                },
              
            ],
            content13:[
           
              {
                type: "list",
                content: "Types of Eczema We Treat",
                items: [
                  "Eczema on the face: We provide gentle treatments to restore skin health and address the visible impact of eczema on the face.",
                  "Dyshidrotic eczema: Our remedies target the hands and feet, providing relief from itching and discomfort.",
                  "Scalp eczema: Treatment is focused on reducing flaking, soothing the scalp,and alleviating itching."
                ],
               
              },
              {
                type: "list1",
                content: "Key Features of Our Eczema Treatment",
                content1: " Our approach to eczema care at H-Cura includes natural remedies eczema that are free of harsh chemicals and tailored to individual needs. We ensure that every treatment addresses both the visible symptoms, like eczema rash, and the underlying causes.",
                items: [
                  "Tailored care plans that address each patient's unique eczema symptoms and triggers",
                  "Safe and gentle remedies suitable for both children and adults, ensuring effective treatment.",
                  "Convenient access to both online and offline consultations,making it easy to start your healing journey from anywhere."
                
                ],
                
              }
            
        ],

        content14:[
          {
            title: "Conclusion",
            content:
              "Eczema, though challenging, is a manageable condition with the right care and expertise. At H-Cura Homeopathy Multispecialty Clinic, we offer the best eczema treatment that prioritizes your well-being and long-term skin health.",
          },
          {
            title: "",
            content:
              "Our treatments provide lasting relief for eczema rashes and severe cases. We help you achieve healthier, itch-free skin through natural remedies and lifestyle management. Your health is our priority.",
          },
        ],
        
        
  },
//psoriasis
    {
      id: "psoriasis",
      name: "psoriasis",
      metadata: [
        {
          title: "Psoriasis Treatment | H-Cura Homeopathy",
          description:
            "Get expert homeopathy treatment for psoriasis at H-Cura Homeopathy. Book your consultation today for safe and effective care.",
          keywords:
            "psoriasis treatment, Homeopathy for psoriasis, H-Cura Homeopathy, Best homeopathy clinic for skin diseases",
          canonicalUrl: "https://www.h-cura.com/treatments/psoriasis",
          favicon: "/assets/images/favicon.ico",
        }
      ],
      content: [
          { type: "heading", content: "Best Homeopathic   Psoriasis Treatment" },
      ],
      content1: [
          {
              type: "image",
              src: bestpsoriasis,
              alt: "psoriasis-image1",
              className: "treatment-banner",
          },
          {
              type: "text",
              content: " Psoriasis Treatment",
              className: "treatment-text",
          },
          {
              type: "link",
              to: "/bookconsultation",
              buttonText: "Book Appointment",
              className: "book-appointment-button",
          },
      ],
      content2:[
          
              { type: "heading", content: "Best Homeopathic psoriasis Treatment" },
          
      ],

      content3: [
          
          {
              type: "heading",
              content: "Psoriasis: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy Multispecialty Clinic",
              className: "treatmentprecautions",
          },
          {
              type: "subheading",
              content: "Understanding Psoriasis",
              className: "treatmentprecautions",
          },
          {
              type: "paragraph",
              content: "soriasis is a long-lasting, non-contagious autoimmune disorder that predominantly affects the skin. This chronic skin condition manifests as an itchy, scaly rash, often occurring on the knees, elbows, trunk, and scalp. It can vary in severity, ranging from small patches to extensive outbreaks.",
              className: "treatmentprecautions",
          },
      ],

      content4:[
         
          {
            type: "list",
            content: "Causes of Psoriasis",
            className: "treatmentinfection1",
            items: [
              "Infections: Bacterial or viral infections can act as triggers.",
              "Skin Injuries: Minor cuts, scrapes, or burns may lead to the development of psoriatic lesions.",
              "Certain Medications: Drugs such as lithium and beta-blockers are known to exacerbate.",
              "Genetics: Family history plays a significant role in the susceptibility to psoriasis.",
              "Other Autoimmune Disorders: Conditions like rheumatoid arthritis may coexist with psoriasis."
            ],
           
          },
          {
            type: "image-overlay",
            src: Psoriasistreatment, // Replace with your actual image path
            alt: "Eczema Treatment Image",
            title: "Book an Appointment",
            description: "Effective solutions to smooth and heal your skin.",
            link: "/bookconsultation",
            buttonText: "Book Appointment",
            
          }
        ],
      content5:[
         
            {
              type: "list",
              content: "Complications of Psoriasis",
              items: [
                "Psoriatic Arthritis: A chronic condition characterized by joint pain, swelling, and stiffness.",
                "Pustular Psoriasis: Marked by pus-filled bumps that can be painful.",
                "Nail Psoriasis: Results in changes to nail appearance, such as pitting or separation."

              
                
              ],
             
            },
            {
              type: "list1",
              content: "Symptoms of Psoriasis",
              content1: "Symptoms can differ from person to person, but common indicators include:",
              items: [
                "Patches of thick red skin with shiny white scales on areas like the elbows, knees, scalp, palms, and soles of the feet.",
                "Psoriasis rash, which is often itchy and uncomfortable.",
                "Specific types like guttate psoriasis, appear as small, dot-like lesions."
                
              ],
              
            }
          
      ],

      content6:[
          {
            type: "paragraph",
            content: "Diagnosis of Psoriasis",
            content1:
              "Diagnosis is primarily based on the appearance of skin plaques and a thorough evaluation of symptoms. A skin biopsy may occasionally be performed to confirm the condition.",
            className: "treatmentDiagnosis"
          },
          
        ],

       content7:[
          
              { src: Psoriasis1, alt: "psoriasis" },
              { src: Psoriasis12, alt: "psoriasis" },
              { src: Psoriasis2, alt: "psoriasis" },
              { src: Psoriasis3, alt: "psoriasis" }
            
       ],
       content8:[
            {
              title1: "Homeopathic Treatment for Psoriasis at H-Cura",
              description1:
                "At H-Cura Homeopathy, we take pride in providing individualized care for every patient. Our treatment approach for psoriasis is rooted in understanding each person’s unique symptoms and triggers.",
             }],
            content9:[   {
                icon: <FaMapMarkerAlt className="feature-icon1" />,
                title: "Tailored Approach",
                description: "Our treatments focus on the individual, ensuring that every symptom is addressed comprehensively."
              },
              {
                icon: <FaUserMd className="feature-icon1" />,
                title: "Natural Remedies for Psoriasis",
                description: "Homeopathic medicines are chosen to stimulate the body’s healing mechanisms without side effects."
              },
              {
                icon: <FaClock className="feature-icon1" />,
                title: "Personalized Follow-Ups",
                description: "Regular monitoring and adjustments ensure the best results."
              }
            ],
            content10:[
              {
                title: "Why Choose H-Cura Homeopathy for Psoriasis Treatment?",
              },
            ],
            content11:[
              {
                description:
                  "Access to excellent medicines for long-lasting relief.",
              },
              {
                description:
                  "Personalized treatment plans designed for individual needs.",
              },
              {
                description:
                  "All services are delivered at your corporate location with minimal disruption.",
              },

            ],
          content12:[
            
              {
                title: "Effective Management of  Psoriasis",
              },
            
          ],
          content13:[
         
            {
              type: "list",
              content: "Types of Psoriasis We Treat",
              items: [
                "Plaque Psoriasis:The most common type, characterized by raised, inflamed patches covered with white scales.",
                "Genital Psoriasis:Requires a delicate approach to treatment.",
                "Psoriasis on hands and feet: This can lead to cracking and discomfort."
                
              ],
             
            },
            {
              type: "list1",
              content: "Key Features of Our Psoriasis Treatment",
              content1: " Our approach to psoriasis care at H-Cura includes natural remedies psoriasis that are free of harsh chemicals and tailored to individual needs. We ensure that every treatment addresses both the visible symptoms, like psoriasis rash, and the underlying causes.",
              items: [
               "Addressing psoriasis causes to minimize flare-ups.",
                "Providing relief for psoriatic arthritis symptoms, including joint pain and swelling.",
                "Managing scalp psoriasis symptoms, such as itching and redness.",
                 "Offering personalized treatment plans tailored to the severity and type of psoriasis.",
                  "Utilizing advanced therapies to reduce inflammation and promote skin healing."
              
              ],
              
            }
          
      ],

      content14:[
        {
          title: "Conclusion",
          content:
            "Psoriasis is a challenging condition, but with the right care, it can be effectively managed. At H-Cura Homeopathy Multispecialty Clinic, our dedicated team is committed to offering the best possible treatment, ensuring relief from symptoms and improved quality of life. Our personalized and holistic approach empowers patients to regain confidence and enjoy healthier, happier lives.",
        },
        {
          title: "",
          content:
            "If you or a loved one is struggling with psoriasis, don’t wait. Contact H-Cura Homeopathy today and embark on your journey toward healing and wellness. <Viral> Your health is our priority.",
        },
      ]

      
  },
//asthma
  {
    id: "asthma",
    name: "asthma",
    metadata: [
      {
        title: "Asthma Treatment | H-Cura Homeopathy",
        description:
          "Find effective homeopathy treatment for asthma at H-Cura Homeopathy. Relieve breathing issues naturally with expert care.",
        keywords:
          "asthma treatment, Homeopathy for asthma, H-Cura Homeopathy, best asthma specialist",
        canonicalUrl: "https://www.h-cura.com/treatments/asthma",
        favicon: "/assets/images/favicon.ico",
      }
    ],
    
    content: [
        { type: "heading", content: "Best Homeopathic   Asthma Treatment" },
    ],
    content1: [
        {
            type: "image",
            src: AsthmaBanner,
            alt: "Asthama-image1",
            className: "treatment-banner",
        },
        {
            type: "text",
            content: "Asthma Treatment",
            className: "treatment-text",
        },
        {
            type: "link",
            to: "/bookconsultation",
            buttonText: "Book Appointment",
            className: "book-appointment-button",
        },
    ],
    content2:[
        
            { type: "heading", content: "Best Homeopathic Asthma Treatment" },
        
    ],

    content3: [
        
        {
            type: "heading",
            content: "Asthma: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy Multispecialty Clinic",
            className: "treatmentprecautions",
        },
        {
            type: "subheading",
            content: "Understanding Asthma",
            className: "treatmentprecautions",
        },
        {
            type: "paragraph",
            content: "Asthma is a rabble-rousing condition of the airways to the lungs, making breathing and physical activities challenging. During an asthma attack, the airways’ lining becomes inflamed, and the muscles around them tighten. This leads to swelling and the production of mucus, which blocks the airways and reduces airflow. Homeopathy offers a holistic approach to managing these symptoms, ensuring natural and sustainable relief.",
            className: "treatmentprecautions",
        },
    ],

    content4:[
       
        {
          type: "list",
          content: "Causes of Asthma",
          className: "treatmentinfection1",
          items: [
            "Allergens: Common triggers include pollen, dust mites, and pet dander.",
            "Respiratory Infections:Viral or bacterial infections can exacerbate asthma.",
            "Environmental Factors:Pollution, smoke, and strong odors may irritate the airways.",
            "Genetics:A family history of asthma increases susceptibility.",
            "Certain Medications: Drugs like aspirin or beta-blockers can worsen symptoms."



            
          ],
         
        },
        {
          type: "image-overlay",
          src: Psoriasistreatment, // Replace with your actual image path
          alt: "Eczema Treatment Image",
          title: "Book an Appointment",
          description: "Effective solutions to smooth heal your breath.",
          link: "/bookconsultation",
          buttonText: "Book Appointment",
          
        }
      ],
    content5:[
       
          {
            type: "list",
            content: "Complications of Asthma",
            items: [
              "Frequent Asthma Attacks: Repeated episodes can damage the airways over time.",
              "Respiratory Failure: Severe cases may result in oxygen deprivation.",
              "Sleep Disturbance: Nighttime symptoms can affect rest and overall health."
              ],
           
          },
          {
            type: "list1",
            content: "Symptoms of Asthma",
            content1: "Symptoms vary in severity and may include:",
            items: [
              "Shortness of Breath, Difficulty breathing, especially during physical activity.",
              "Wheezing, A high-pitched sound while breathing, particularly during exhalation.",
              "Persistent Cough, Often worse at night or early morning.",
              "Chest Tightness, A feeling of pressure or discomfort in the chest.",
              "Asthma Attack Symptoms, Severe breathing difficulties, and rapid heartbeat.",
              "Allergic Asthma Symptoms, Accompanied by sneezing and nasal congestion."
                        
              
            ],
            
          }
        
    ],

    content6:[
        {
          type: "paragraph",
          content: "Diagnosis of Asthma",
          content1:
            "Asthma diagnosis involves:The diagnosis of asthma involves a comprehensive approach, beginning with a detailed medical history and symptom assessment to understand the patient's health background and current issues. Lung function tests, such as spirometry, are conducted to evaluate the airflow and capacity of the lungs. Additionally, allergy testing may be performed to identify potential triggers or allergens that could exacerbate asthma symptoms.",
          className: "treatmentDiagnosis"
        },
        
      ],

     content7:[
        
            { src: Asthma1, alt: "Asthma" },
            { src: Asthma2, alt: "Asthma"},
            { src: Asthma3, alt: "Asthma" },
            { src: Asthma4, alt: "Asthma" },
          
     ],
     content8:[
          {
            title1: "Homeopathic Treatment for Asthma at H-Cura",
            description1:
              "At H-Cura Homeopathy Multispecialty Clinic, we specialize in personalized homeopathic treatments for asthma. Our approach addresses the root causes of the condition, providing natural and effective solutions.",
           }],
          content9:[   {
              icon: <FaMapMarkerAlt className="feature-icon1" />,
              title: "Tailored Approach",
              description: "Each treatment plan is customized to the individual’s symptoms and triggers, ensuring comprehensive care."
            },
            {
              icon: <FaUserMd className="feature-icon1" />,
              title: "Natural Remedies for Asthma",
              description: "Homeopathic medicines stimulate the body’s innate healing processes without causing side effects."
            },
            {
              icon: <FaClock className="feature-icon1" />,
              title: "Personalized Follow-Ups",
              description: "Regular consultations help monitor progress and adjust the treatment as needed."
            }
          ],
          content10:[
            {
              title: "Why Choose H-Cura Homeopathy for Asthma Treatment?",
            },
          ],
          content11:[
            {
              description:
                "Holistic Management: Comprehensive approach to managing asthma symptoms and triggers.",
            },
            {
              description:
                "Safe and Effective Remedies:Side-effect-free treatments providing effective asthma relief.",
            },
            {
              description:
                "Expert Care for All Ages: Specialized expertise in treating cough variant asthma, allergic asthma, and tailored care for both children and adults.",
            },

          ],
        content12:[
          
            {
              title: "Stages and Homeopathic Treatment",
            },
          
        ],
        content13:[
       
          {
            type: "list",
            content: "Types of Psoriasis We Treat",
            items: [
              "Mild Intermittent:Managed with remedies that prevent occasional flare-ups.",
              "Mild Persistent:Treated with medicines targeting frequent symptoms.",
              "Moderate Persistent: Comprehensive care to address daily symptoms.",
              "Severe Persistent: Advanced remedies to manage chronic and severe cases."


              
              
            ],
           
          },
          {
            type: "list1",
            content: "Key Features of Our Asthma Treatment",
            content1: " Our approach to Asthma care at H-Cura includes natural remedies Asthma that are free of harsh chemicals and tailored to individual needs. We ensure that every treatment addresses both the visible symptoms, like Asthma and the underlying causes.",
            items: [
             "Addressing underlying causes to minimize asthma symptoms.",
             "Providing natural remedies for conditions like asthma cough and exercise-induced asthma.",
            "Helping manage allergic asthma symptoms effectively."
            ],
            
          }
        
    ],

    content14:[
      {
        title: "Conclusion",
        content:
          "Asthma, though challenging, can be managed effectively with the right treatment. At H-Cura Homeopathy Multispecialty Clinic, our holistic and personalized approach ensures lasting relief and improved quality of life. By targeting the root causes, we help patients achieve better control over their symptoms and lead healthier lives.",
      },
      {
        title: "",
        content:
          "If you or your loved ones are seeking a natural and effective solution for asthma, contact H-Cura Homeopathy today. Let us guide you toward a healthier, asthma-free life. Your wellness is our commitment.",
      },
    ]

    
},
//diabetes   
{
  id: "diabetes",
  name: "diabetes",
  metadata: [
    {
      title: "Diabetes Treatment | H-Cura Homeopathy",
      description:
        "Manage diabetes effectively with homeopathy at H-Cura Homeopathy. Safe and natural solutions for better health.",
      keywords:
        "diabetes treatment, Homeopathy for diabetes, H-Cura Homeopathy, natural diabetes management",
      canonicalUrl: "https://www.h-cura.com/treatments/diabetes",
      favicon: "/assets/images/favicon.ico",
    }
  ],
  
  content: [
      { type: "heading", content: "Best Homeopathic   diabetes Treatment" },
  ],
  content1: [
      {
          type: "image",
          src: diabetesBanner,
          alt: "diabetes",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "Diabetes Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2:[
      
          { type: "heading", content: "Best Homeopathic Diabetes Treatment" },
      
  ],

  content3: [
      
      {
          type: "heading",
          content: "Diabetes: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Diabetes",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: " Diabetes is a chronic metabolic condition characterized by high blood sugar levels due to insufficient insulin production or ineffective use of insulin. It can affect individuals of any age and may lead to various complications if not managed effectively.",
          className: "treatmentprecautions",
      },
  ],

  content4:[
     
      {
        type: "list",
        content: "Causes of Diabetes",
        className: "treatmentinfection1",
        items: [
          "Genetic factors: A family history of diabetes increases the risk.",
          "Lifestyle factors:Poor diet, lack of physical activity, and obesity contribute significantly to Type 2 Diabetes.",
          "Autoimmune responses:In Type 1 Diabetes, the immune system destroys insulin-producing cells.",
          "Hormonal changes:During pregnancy, hormonal imbalances can lead to Gestational Diabetes."
          ],
       
      },
      {
        type: "image-overlay",
        src: diabetesappointment, // Replace with your actual image path
        alt: "diabetes Treatment Image",
        title: "Book an Appointment  ",
        description: "Effective solutions to smooth heal your health.",
        link: "/bookconsultation",
        buttonText: "Book Appointment",
        
      }
    ],
  content5:[
     
        {
          type: "list",
          content: "Complications of Diabetes",
          items: [
            "Cardiovascular disease: Increased risk of heart attacks and strokes.",
            "Neuropathy:Damage to nerves, particularly in the extremities",
            "Nephropathy:Kidney damage, potentially leading to kidney failure.",
            "Retinopathy:Eye damage, which can result in blindness.",
            "Foot ulcers:These can lead to infections and even amputations."


           
            ],
         
        },
        {
          type: "list1",
          content: "Symptoms of Diabetes",
          content1: "Symptoms of diabetes can range from mild to severe and may include:",
          items: [
            "Increased thirst and frequent urination: Caused by high blood sugar levels.",
            "Fatigue: Due to the body's inability to use glucose for energy.",
            "Unexplained weight loss: Common in Type 1 Diabetes.",
            "Slow-healing wounds: High sugar levels impair healing.",
            "Blurred vision: Caused by fluid shifts in the lenses of the eyes.",
            "Frequent infections: Especially in the skin, gums, or urinary tract."
                      
            
          ],
          
        }
      
  ],

  content6:[
      {
        type: "paragraph",
        content: "Diagnosis of Diabetes",
        content1:
          "At H-Cura Homeopathy, we adopt a comprehensive approach to diagnosing diabetes. This includes a detailed medical history review to identify risk factors and family history, along with blood tests such as fasting blood sugar, HbA1c, and glucose tolerance tests. Additionally, we focus on identifying complications to enable early detection of diabetes-related issues and provide targeted management.",
        className: "treatmentDiagnosis"
      },
      
    ],

   content7:[
      
          { src: diabetes1, alt: "diabetes" },
          { src: diabetes2, alt: "diabetes" },
          { src: diabetes3, alt: "diabetes"},
          { src: diabetes4, alt: "diabetes" }
        
   ],
   content8:[
        {
          title1: "Homeopathic Treatment for Diabetes at H-Cura",
          description1:
            "Our homeopathic treatments focus on addressing the root causes of diabetes and promoting long-term health. By supporting the body's natural healing processes, our remedies are safe and effective.",
         }],
        content9:[   {
            icon: <FaMapMarkerAlt className="feature-icon1" />,
            title: "Blood sugar control: ",
            description: "Remedies aimed at regulating blood glucose levels naturally."
          },
          {
            icon: <FaUserMd className="feature-icon1" />,
            title:"Immune system support:",
            description: "Particularly important for Type 1 Diabetes"
          },
          {
            icon: <FaClock className="feature-icon1" />,
            title: "Reducing dependency on conventional medications:",
            description: "Gradual transition under medical supervision."
          }
        ],
        content10:[
          {
            title: "Why Choose H-Cura Homeopathy for Diabetes Treatment?",
          },
        ],
        content11:[
          {
            description:
              "H-Cura Homeopathy offers a patient-centric approach to diabetes care. Our team of experienced practitioners ensures that every patient receives personalized treatment tailored to their unique symptoms and health goals.",
          },
          {
            description:
              "At H-Cura Homeopathy, we focus on a holistic approach to improve overall health and wellness while addressing diabetes.",
          },
          {
            description:
              "Our experienced practitioners provide patient-centric care, tailoring treatments to meet your unique needs and lifestyle.",
          },

        ],
      content12:[
        
          {
            title: "Effective Management of Diabetes",
          },
        
      ],
      content13:[
     
        {
          type: "list",
          content: "Types of Diabetes We Treat Our expertise extends to managing all forms of diabetes:",
          items: [
            "Type 1 Diabetes: Focused on immune modulation and symptom control.",
            "Type 2 Diabetes: Emphasis on lifestyle modifications and metabolic balance",
            "Gestational Diabetes: Specialized care for pregnant women to ensure the health of both mother and child."

           
            
          ],
         
        },
        {
          type: "list1",
          content: "Key Features of Our Diabetes Treatment",
          content1: " Our approach to diabetes care at H-Cura includes natural remedies that are free of side effects and tailored to individual needs.",
          items: [

            "Care plans are tailored to your unique diabetes profile and health goals.",
            "Treatments include safe and gentle remedies suitable for all ages, including pregnant women.",
            "Convenient access is available through both online and offline consultations."
           
          ],
          
        }
      
  ],

  content14:[
    {
      title: "Conclusion",
      content:
        "Diabetes, though challenging, is a manageable condition with the right care and expertise. At H-Cura Homeopathy Multispecialty Clinic, we offer the best diabetes treatment that prioritizes your well-being and long-term health.",
    },
    {
      title: "",
      content:
        "Our treatments provide effective relief, from blood sugar control to managing complications, ensuring lasting results. We focus on holistic care by combining natural remedies with lifestyle management to help you achieve better overall health.<span>Your wellness is our commitment.",
    },
  ]

  
},
//migrane
{
  id: "migraine",
  name: "migraine",
  metadata: [
    {
      title: "Migraine Treatment | H-Cura Homeopathy",
      description:
        "Say goodbye to migraine pain with expert homeopathy treatment at H-Cura Homeopathy. Book a consultation today.",
      keywords:
        "migraine treatment, Homeopathy for migraine, H-Cura Homeopathy, headache relief",
      canonicalUrl: "https://www.h-cura.com/treatments/migraine",
      favicon: "/assets/images/favicon.ico",
    }
  ],
  
  content: [
      { type: "heading", content: " Best Homeopathic Migraine Treatment at H-Cura Homeopathy Multispecialty Clinic" },
  ],
  content1: [
      {
          type: "image",
          src: migranebanner,
          alt: "migranebanner",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "migraine Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2:[
      
          { type: "heading", content: "Best Homeopathic Migraine Treatment" },
      
  ],

  content3: [
      
      {
          type: "heading",
          content: "Migraine: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Migraines",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: " Migraines are neurological conditions often characterized by intense, throbbing headaches accompanied by other symptoms like nausea and sensitivity to light or sound. They can last from a few hours to several days and significantly affect quality of life.",
          className: "treatmentprecautions",
      },
  ],

  content4:[
     
      {
        type: "list",
        content: "Causes of Migraines",
        className: "treatmentinfection1",
        items: [
          "Genetic predisposition: Family history increases susceptibility.",
          "Hormonal changes: Common in women during menstruation, pregnancy, or menopause.",
          "Stress and anxiety: Emotional stress can trigger migraines.",
          "Dietary factors: Certain foods or beverages like caffeine or alcohol may provoke migraines.",
          "Environmental triggers: Strong smells, bright lights, or weather changes."
          ],
       
      },
      {
        type: "image-overlay",
        src: migranappointment, // Replace with your actual image path
        alt: "migrane Treatment Image",
        title: "Book an Appointment",
        description: "Effective solutions to smooth heal your health.",
        link: "/bookconsultation",
        buttonText: "Book Appointment",
        
      }
    ],
  content5:[
     
        {
          type: "list",
          content: " Complications of Migraines When left unmanaged, migraines can lead to: ",
          items: [
            "Chronic migraine: Frequent episodes severely affecting daily life.",
            "Medication overuse headaches: Resulting from excessive use of pain relievers",
            "Mental health issues: Including anxiety and depression.",
            "Stroke: Rare, but migraines with aura slightly increase stroke risk.",
            ],
         
        },
        {
          type: "list1",
          content: "Symptoms of Migraines ",
          content1: "Migraine symptoms can vary but often include:",
          items: [
            "Intense, throbbing headache: Typically on one side of the head.",
            "Nausea and vomiting: Commonly accompany the headache",
            "Sensitivity to light and sound: Making it difficult to function normally.",
            "Aura: Visual disturbances such as flashing lights or blind spots.",
            "Fatigue and irritability: Both during and after migraine episodes.",
                      
            
          ],
          
        }
      
  ],

  content6:[
      {
        type: "paragraph",
        content: " Diagnosis of Migraines",
        content1:
          "At H-Cura Homeopathy, we employ a comprehensive approach to diagnosing migraines:",
        className: "treatmentDiagnosis"
      },
      
    ],

   content7:[
      
          { src: migrane1, alt: "migrane" },
          { src: migrane2, alt: "migrane" },
          { src: migrane3, alt: "migrane"},
          { src: migrane4, alt: "migrane" }
        
   ],
   content8:[
        {
          title1: "Homeopathic Treatment for Migraines at H-Cura",
          description1:
            "Our homeopathic treatments address the root causes of migraines while promoting long-term relief and improved well-being.",
         }],
        content9:[   {
            icon: <FaMapMarkerAlt className="feature-icon1" />,
            title: "Trigger management: ",
            description: "Remedies to reduce sensitivity to common triggers."
          },
          {
            icon: <FaUserMd className="feature-icon1" />,
            title:"Pain relief:",
            description: " Effective treatment for headache and associated symptoms."
          },
          {
            icon: <FaClock className="feature-icon1" />,
            title: "Preventive care: ",
            description: "Focused on reducing the frequency and intensity of attacks."
          },
          // {
          //   icon: <FaClock className="feature-icon1" />,
          //   title: "Holistic support: ",
          //   description: "Enhancing overall health and resilience."
          // }
        ],
        content10:[
          {
            title: " Why Choose H-Cura Homeopathy for Migraine Treatment?",
          },
        ],
        content11:[
          {
            description:
              "H-Cura Homeopathy is committed to providing patient-centered care with a focus on effective migraine management.",
          },
          {
            description:
              "Holistic approach: Treating the whole person, not just the symptoms.",
          },
          {
            description:
              "Experienced practitioners: Skilled in handling complex migraine cases.",
          },
          // {
          //   description:
          //   "Individualized care: Customized remedies for your unique needs.",
          // }

        ],
      content12:[
        
          {
            title: "Effective Management of Migraines",
          },
        
      ],
      content13:[
     
        {
          type: "list",
          content: "Our comprehensive approach combines personalized diet and lifestyle recommendations with homeopathic remedies to ensure effective migraine management.",
          items: [
            "Chronic Migraine: Targeted therapies to reduce frequency and severity.",
            "Episodic Migraine: Remedies to prevent progression to chronic conditions.",
            "Cluster Headaches: Specialized care for acute and recurring episodes."

           
            
          ],
         
        },
        {
          type: "list1",
          content: "Key Features of Our Migraine Treatment",
          content1: " Our approach to diabetes care at H-Cura includes natural remedies that are free of side effects and tailored to individual needs.At H-Cura, we provide natural, non-invasive migraine remedies that are free of side effects.",
          items: [

            "Customized care plans: Tailored to your migraine profile and health goals.",
            "Safe and gentle remedies: Suitable for all age groups, including children.",
            "Accessible care: Online and offline consultations for convenience."
           
          ],
          
        }
      
  ],

  content14:[
    {
      title: "Conclusion",
      content:
        "DMigraines, while challenging, are manageable with the right care and expertise. At H-Cura Homeopathy Multispecialty Clinic, we provide top-notch migraine treatment focused on your long-term health and well-being.",
    },
    {
      title: "",
      content:
        "Effective relief: From acute pain to preventive care, our treatments offer lasting benefits.",
    },
    {
      title: "",
      content:
        " Holistic care: Achieve better health through natural remedies and lifestyle adjustments.",
    },

  ]

  
},
//alopecia
{
  id: "alopecia-areata",
  name: "alopecia-areata",
  metadata: [
    {
      title: "Alopecia Areata Treatment | H-Cura Homeopathy",
      description: "Get expert homeopathy treatment for alopecia areata at H-Cura Homeopathy. Safe, natural, and effective solutions for hair regrowth. Book your consultation today.",
      keywords: "Alopecia areata treatment, Homeopathy for hair loss, Hair regrowth treatment, H-Cura Homeopathy, Best homeopathy for alopecia",
      canonicalUrl: "https://www.h-cura.com/treatments/alopecia-areata",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Alopecia Areata Treatment" }
  ],
  content1: [
    {
      type: "image",
      src: alopecia,
      alt: "alopecia-areata-image1",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Alopecia Areata Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Best Homeopathic Alopecia Areata Treatment" }
  ],
  content3: [
    {
      type: "heading",
      content: "Alopecia Areata: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Alopecia Areata",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Alopecia areata is an autoimmune condition that causes hair loss in patches on the scalp and other parts of the body. It occurs when the immune system mistakenly attacks hair follicles, leading to hair fall. This condition can affect individuals of any age and gender, often causing emotional distress due to its visible impact. Early intervention with homeopathy can help stimulate hair regrowth and prevent further hair loss.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Causes of Alopecia Areata",
      className: "treatmentinfection1",
      items: [
        "Autoimmune Disorders: The immune system attacks hair follicles, leading to hair loss.",
        "Genetic Factors: A family history of alopecia or autoimmune diseases increases the risk.",
        "Stress: Emotional or physical stress can trigger or worsen alopecia areata.",
        "Hormonal Imbalances: Thyroid disorders or hormonal changes can contribute to hair loss.",
        "Environmental Factors: Exposure to toxins or allergens may trigger the condition."
      ]
    },
    {
      type: "image-overlay",
      src: alopeciatreatment,
      alt: "Alopecia Areata Treatment Image",
      title: "Book an Appointment",
      description: "Effective solutions for hair regrowth and scalp health.",
      link: "/bookconsultation",
      buttonText: "Book Appointment"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of Alopecia Areata",
      items: [
        "Emotional distress and low self-esteem due to visible hair loss.",
        "Complete hair loss (Alopecia Totalis) in severe cases.",
        "Nail changes, such as pitting or ridges, may accompany hair loss."
      ]
    },
    {
      type: "list1",
      content: "Symptoms of Alopecia Areata",
      content1: "The primary symptom of alopecia areata is patchy hair loss on the scalp, beard, or other body parts. Other symptoms include:",
      items: [
        "Sudden hair loss in round or oval patches.",
        "Itching or burning sensation on the scalp before hair falls out.",
        "Regrowth of white or fine hair in affected areas."
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of Alopecia Areata",
      content1: "At H-Cura Homeopathy, we diagnose alopecia areata through a detailed medical history, physical examination, and, if necessary, a scalp biopsy. Our holistic approach ensures accurate diagnosis and personalized treatment plans.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: alopecia1, alt: "alopecia-areata" },
    { src: alopecia2, alt: "alopecia-areata" },
    { src: alopecia3, alt: "alopecia-areata" },
    { src: alopecia4, alt: "alopecia-areata" }
  ],
  content8: [
    {
      title1: "Homeopathic Treatment for Alopecia Areata at H-Cura",
      description1: "Our homeopathic treatments focus on addressing the root causes of alopecia areata, such as autoimmune triggers and stress. We use natural remedies to stimulate hair regrowth and improve overall scalp health."
    }
  ],
  content9: [
    {
      icon: <FaMapMarkerAlt className="feature-icon1" />,
      title: "Strengthen the Immune System",
      description: "We focus on rebalancing the immune system to prevent further hair loss."
    },
    {
      icon: <FaUserMd className="feature-icon1" />,
      title: "Promote Hair Regrowth",
      description: "Our remedies stimulate hair follicles and encourage healthy hair growth."
    },
    {
      icon: <FaClock className="feature-icon1" />,
      title: "Personalized Follow-Ups",
      description: "Regular monitoring ensures the best results for each patient."
    }
  ],
  content10: [
    {
      title: "Why Choose H-Cura Homeopathy for Alopecia Areata Treatment?"
    }
  ],
  content11: [
    {
      description: "Our treatment addresses the root causes of alopecia areata and promotes long-term hair regrowth."
    },
    {
      description: "With years of experience, our practitioners provide expert care for autoimmune hair loss."
    },
    {
      description: "We offer personalized treatment plans tailored to each patient's unique needs."
    }
  ],
  content12: [
    {
      title: "Effective Management of Alopecia Areata"
    }
  ],
  content13: [
    {
      type: "list",
      content: "Types of Alopecia We Treat",
      items: [
        "Patchy Alopecia Areata: Hair loss in small, round patches.",
        "Alopecia Totalis: Complete hair loss on the scalp.",
        "Alopecia Universalis: Hair loss across the entire body."
      ]
    },
    {
      type: "list1",
      content: "Key Features of Our Alopecia Treatment",
      content1: "Our approach includes natural remedies that are safe, gentle, and effective for all age groups.",
      items: [
        "Tailored care plans for each patient's unique condition.",
        "Safe and natural remedies with no side effects.",
        "Convenient online and offline consultations."
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Alopecia areata can be emotionally challenging, but with the right treatment, hair regrowth is possible. At H-Cura Homeopathy, we provide safe, natural, and effective solutions for managing alopecia areata and restoring your confidence."
    },
    {
      title: "",
      content: "Our holistic approach ensures long-term results by addressing the root causes of hair loss. Book your consultation today and take the first step toward healthier hair."
    }
  ]
},
//pcod-pcos
{
  id: "pcod-pcos",
  name: "PCOD/PCOS",
  metadata: [
    {
      title: "PCOD/PCOS Treatment | H-Cura Homeopathy",
      description: "Get effective homeopathic treatment for PCOD/PCOS at H-Cura Homeopathy. Manage symptoms naturally and restore hormonal balance. Book your consultation today.",
      keywords: "PCOD treatment, PCOS treatment, Homeopathy for PCOD, Homeopathy for PCOS, H-Cura Homeopathy, Hormonal imbalance treatment",
      canonicalUrl: "https://www.h-cura.com/treatments/pcod-pcos",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for PCOD/PCOS" }
  ],
  content1: [
    {
      type: "image",
      src: pcodpcos,
      alt: "pcod-pcos-image1",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "PCOD/PCOS Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Best Homeopathic Treatment for PCOD/PCOS" }
  ],
  content3: [
    {
      type: "heading",
      content: "PCOD/PCOS: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding PCOD/PCOS",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Polycystic Ovarian Disease (PCOD) and Polycystic Ovarian Syndrome (PCOS) are hormonal disorders affecting women of reproductive age. These conditions lead to irregular menstrual cycles, weight gain, acne, and infertility. PCOD/PCOS can also cause emotional distress due to its impact on physical appearance and fertility.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Causes of PCOD/PCOS",
      className: "treatmentinfection1",
      items: [
        "Hormonal Imbalance: Elevated levels of androgens (male hormones) disrupt ovulation.",
        "Insulin Resistance: High insulin levels increase androgen production.",
        "Genetic Factors: Family history of PCOD/PCOS increases the risk.",
        "Lifestyle Factors: Poor diet, lack of exercise, and stress contribute to PCOD/PCOS.",
        "Inflammation: Chronic inflammation is linked to higher androgen levels."
      ]
    },
    {
      type: "image-overlay",
      src: pcodtreatment,
      alt: "PCOD/PCOS Treatment Image",
      title: "Book an Appointment",
      description: "Restore hormonal balance naturally with homeopathy.",
      link: "/bookconsultation",
      buttonText: "Book Appointment"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of PCOD/PCOS",
      items: [
        "Infertility: Irregular ovulation makes conception difficult.",
        "Metabolic Syndrome: Increased risk of diabetes, high blood pressure, and heart disease.",
        "Mental Health Issues: Anxiety and depression due to hormonal imbalances.",
        "Endometrial Cancer: Prolonged irregular periods increase the risk."
      ]
    },
    {
      type: "list1",
      content: "Symptoms of PCOD/PCOS",
      content1: "Common symptoms include irregular periods, weight gain, acne, excessive hair growth, and hair thinning. These symptoms vary in severity and can significantly impact quality of life.",
      items: [
        "Irregular or absent menstrual cycles.",
        "Weight gain, especially around the abdomen.",
        "Acne and oily skin.",
        "Excessive hair growth on the face and body."
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of PCOD/PCOS",
      content1: "At H-Cura Homeopathy, we diagnose PCOD/PCOS through a detailed medical history, physical examination, and hormonal tests. Ultrasound imaging helps identify ovarian cysts, while blood tests measure hormone levels.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: pcodgallery1, alt: "PCOD/PCOS" },
    { src: pcodgallery2, alt: "PCOD/PCOS" },
    { src: pcodgallery3, alt: "PCOD/PCOS" },
    { src: pcodgallery4, alt: "PCOD/PCOS" }
  ],
  content8: [
    {
      title1: "Homeopathic Treatment for PCOD/PCOS at H-Cura",
      description1: "Our homeopathic treatments focus on balancing hormones, improving metabolism, and addressing the root causes of PCOD/PCOS. We provide safe, natural remedies tailored to each patient's needs."
    }
  ],
  content9: [
    {
      icon: <FaMapMarkerAlt className="feature-icon1" />,
      title: "Hormonal Balance",
      description: "We restore hormonal balance to regulate menstrual cycles."
    },
    {
      icon: <FaUserMd className="feature-icon1" />,
      title: "Weight Management",
      description: "Our remedies help manage weight and improve metabolism."
    },
    {
      icon: <FaClock className="feature-icon1" />,
      title: "Personalized Care",
      description: "Regular follow-ups ensure optimal results."
    }
  ],
  content10: [
    {
      title: "Why Choose H-Cura Homeopathy for PCOD/PCOS Treatment?"
    }
  ],
  content11: [
    {
      description: "Our treatment addresses the root causes of PCOD/PCOS and promotes overall health."
    },
    {
      description: "We offer personalized care plans tailored to each patient's symptoms and lifestyle."
    },
    {
      description: "Our natural remedies are safe, effective, and free from side effects."
    }
  ],
  content12: [
    {
      title: "Effective Management of PCOD/PCOS"
    }
  ],
  content13: [
    {
      type: "list",
      content: "Types of PCOD/PCOS We Treat",
      items: [
        "Insulin-resistant PCOS: Focus on improving insulin sensitivity.",
        "Post-pill PCOS: Treatment for PCOS triggered by birth control pills.",
        "Inflammatory PCOS: Addressing chronic inflammation and its effects."
      ]
    },
    {
      type: "list1",
      content: "Key Features of Our PCOD/PCOS Treatment",
      content1: "Our approach includes natural remedies, lifestyle guidance, and regular monitoring to ensure long-term relief.",
      items: [
        "Tailored treatment plans for hormonal balance.",
        "Safe and effective remedies for all age groups.",
        "Comprehensive care for physical and emotional well-being."
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "PCOD/PCOS can be effectively managed with the right treatment and care. At H-Cura Homeopathy, we provide natural, holistic solutions to restore hormonal balance and improve quality of life."
    },
    {
      title: "",
      content: "Our treatments focus on addressing the root causes of PCOD/PCOS, ensuring long-term relief and overall well-being. Book your consultation today and take the first step towards a healthier you."
    }
  ]
},
//irritable
{
  id: "irritable-bowel-syndrome",
  name: "irritable-bowel-syndrome",
  metadata: [
    {
      title: "Irritable Bowel Syndrome Treatment | H-Cura Homeopathy",
      description: "Get expert homeopathy treatment for IBS at H-Cura Homeopathy. Relieve symptoms like bloating, cramps, and irregular bowel movements naturally. Book your consultation today.",
      keywords: "IBS treatment, Homeopathy for IBS, Irritable bowel syndrome, H-Cura Homeopathy, Best homeopathy for digestive disorders",
      canonicalUrl: "https://www.h-cura.com/treatments/irritable-bowel-syndrome",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic IBS Treatment" }
  ],
  content1: [
    {
      type: "image",
      src: ibs,
      alt: "ibs-image1",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "IBS Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Best Homeopathic IBS Treatment" }
  ],
  content3: [
    {
      type: "heading",
      content: "Irritable Bowel Syndrome: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding IBS",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Irritable Bowel Syndrome (IBS) is a common digestive disorder that affects the large intestine. It causes symptoms like abdominal pain, bloating, gas, diarrhea, and constipation. IBS can significantly impact daily life and overall well-being. Homeopathy offers a natural and effective way to manage IBS symptoms and improve digestive health.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Causes of IBS",
      className: "treatmentinfection1",
      items: [
        "Dietary Factors: Certain foods like dairy, gluten, and spicy foods can trigger IBS.",
        "Stress: Emotional stress and anxiety can worsen IBS symptoms.",
        "Gut Microbiome Imbalance: Disruption in gut bacteria can lead to digestive issues.",
        "Hormonal Changes: Women may experience worsened symptoms during menstruation.",
        "Genetic Predisposition: A family history of IBS increases the risk."
      ]
    },
    {
      type: "image-overlay",
      src: ibstreatment,
      alt: "IBS Treatment Image",
      title: "Book an Appointment",
      description: "Effective solutions for digestive health and symptom relief.",
      link: "/bookconsultation",
      buttonText: "Book Appointment"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of IBS",
      items: [
        "Chronic discomfort and pain affecting daily activities.",
        "Nutritional deficiencies due to poor digestion and absorption.",
        "Mental health issues like anxiety and depression due to persistent symptoms."
      ]
    },
    {
      type: "list1",
      content: "Symptoms of IBS",
      content1: "IBS symptoms vary but commonly include:",
      items: [
        "Abdominal pain and cramping, often relieved by bowel movements.",
        "Bloating and excessive gas.",
        "Alternating diarrhea and constipation."
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of IBS",
      content1: "At H-Cura Homeopathy, we diagnose IBS through a detailed medical history, physical examination, and ruling out other conditions. Our holistic approach ensures accurate diagnosis and personalized treatment plans.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: ibs1, alt: "ibs" },
    { src: ibs2, alt: "ibs" },
    { src: ibs3, alt: "ibs" },
    { src: ibs4, alt: "ibs" }
  ],
  content8: [
    {
      title1: "Homeopathic Treatment for IBS at H-Cura",
      description1: "Our homeopathic treatments focus on addressing the root causes of IBS, such as stress, dietary triggers, and gut health. We use natural remedies to relieve symptoms and improve digestive function."
    }
  ],
  content9: [
    {
      icon: <FaMapMarkerAlt className="feature-icon1" />,
      title: "Relieve Symptoms Naturally",
      description: "We focus on reducing bloating, cramps, and irregular bowel movements."
    },
    {
      icon: <FaUserMd className="feature-icon1" />,
      title: "Improve Gut Health",
      description: "Our remedies restore balance to the gut microbiome."
    },
    {
      icon: <FaClock className="feature-icon1" />,
      title: "Personalized Follow-Ups",
      description: "Regular monitoring ensures long-term relief."
    }
  ],
  content10: [
    {
      title: "Why Choose H-Cura Homeopathy for IBS Treatment?"
    }
  ],
  content11: [
    {
      description: "Our treatment addresses the root causes of IBS and promotes digestive health."
    },
    {
      description: "With years of experience, our practitioners provide expert care for digestive disorders."
    },
    {
      description: "We offer personalized treatment plans tailored to each patient's unique needs."
    }
  ],
  content12: [
    {
      title: "Effective Management of IBS"
    }
  ],
  content13: [
    {
      type: "list",
      content: "Types of IBS We Treat",
      items: [
        "IBS-D (Diarrhea-predominant): Frequent diarrhea and urgency.",
        "IBS-C (Constipation-predominant): Difficulty passing stools.",
        "IBS-M (Mixed): Alternating diarrhea and constipation."
      ]
    },
    {
      type: "list1",
      content: "Key Features of Our IBS Treatment",
      content1: "Our approach includes natural remedies that are safe, gentle, and effective for all age groups.",
      items: [
        "Tailored care plans for each patient's unique condition.",
        "Safe and natural remedies with no side effects.",
        "Convenient online and offline consultations."
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "IBS can disrupt your daily life, but with the right treatment, symptom relief is possible. At H-Cura Homeopathy, we provide safe, natural, and effective solutions for managing IBS and improving digestive health."
    },
    {
      title: "",
      content: "Our holistic approach ensures long-term results by addressing the root causes of IBS. Book your consultation today and take the first step toward better digestive health."
    }
  ]
},
//hairfall
{
  id: "hair-fall",
  name: "hair-fall",
  metadata: [
    {
      title: "Hair Fall Treatment | H-Cura Homeopathy",
      description: "Stop hair fall and promote hair growth with safe and effective homeopathic treatments at H-Cura Homeopathy. Book your consultation today.",
      keywords: "Hair fall treatment, Homeopathy for hair fall, Hair growth treatment, H-Cura Homeopathy, Best homeopathy clinic for hair fall",
      canonicalUrl: "https://www.h-cura.com/treatments/hairfall",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Hair Fall" }
  ],
  content1: [
    {
      type: "image",
      src: hairfall,
      alt: "hairfall-image1",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Hair Fall Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Best Homeopathic Treatment for Hair Fall" }
  ],
  content3: [
    {
      type: "heading",
      content: "Hair Fall: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Hair Fall",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Hair fall is a common condition affecting both men and women. It can be caused by factors such as stress, hormonal imbalances, nutritional deficiencies, and genetic predisposition. Severe hair fall can lead to thinning hair and bald patches, impacting self-esteem.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Causes of Hair Fall",
      className: "treatmentinfection1",
      items: [
        "Hormonal Imbalance: Conditions like thyroid disorders and PCOS can cause hair fall.",
        "Nutritional Deficiencies: Lack of essential vitamins and minerals like iron and biotin.",
        "Stress: Physical or emotional stress can trigger hair fall.",
        "Genetic Factors: Family history of baldness or thinning hair.",
        "Scalp Infections: Fungal or bacterial infections can damage hair follicles."
      ]
    },
    {
      type: "image-overlay",
      src: hairfalltreatment,
      alt: "Hair Fall Treatment Image",
      title: "Book an Appointment",
      description: "Regrow your hair naturally with homeopathy.",
      link: "/bookconsultation",
      buttonText: "Book Appointment"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of Hair Fall",
      items: [
        "Baldness: Severe hair fall can lead to permanent hair loss.",
        "Low Self-Esteem: Thinning hair can affect confidence and emotional well-being.",
        "Scalp Infections: Chronic hair fall can lead to scalp issues."
      ]
    },
    {
      type: "list1",
      content: "Symptoms of Hair Fall",
      content1: "Common symptoms include excessive hair shedding, thinning hair, and bald patches. Early intervention can prevent further hair loss.",
      items: [
        "Excessive hair on pillows or combs.",
        "Visible thinning of hair on the scalp.",
        "Bald patches or receding hairline."
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of Hair Fall",
      content1: "At H-Cura Homeopathy, we diagnose hair fall through a detailed medical history, scalp examination, and blood tests to identify underlying causes like hormonal imbalances or nutritional deficiencies.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: hairfallgallery1, alt: "Hair Fall" },
    { src: hairfallgallery2, alt: "Hair Fall" },
    { src: hairfallgallery3, alt: "Hair Fall" },
    { src: hairfallgallery4, alt: "Hair Fall" }
  ],
  content8: [
    {
      title1: "Homeopathic Treatment for Hair Fall at H-Cura",
      description1: "Our homeopathic treatments focus on addressing the root causes of hair fall, promoting hair growth, and improving scalp health. We provide natural, safe remedies tailored to each patient's needs."
    }
  ],
  content9: [
    {
      icon: <FaMapMarkerAlt className="feature-icon1" />,
      title: "Hair Growth",
      description: "We stimulate hair follicles to promote natural hair growth."
    },
    {
      icon: <FaUserMd className="feature-icon1" />,
      title: "Scalp Health",
      description: "Our remedies improve scalp health and prevent infections."
    },
    {
      icon: <FaClock className="feature-icon1" />,
      title: "Personalized Care",
      description: "Regular follow-ups ensure optimal results."
    }
  ],
  content10: [
    {
      title: "Why Choose H-Cura Homeopathy for Hair Fall Treatment?"
    }
  ],
  content11: [
    {
      description: "Our treatment addresses the root causes of hair fall and promotes healthy hair growth."
    },
    {
      description: "We offer personalized care plans tailored to each patient's needs."
    },
    {
      description: "Our natural remedies are safe, effective, and free from side effects."
    }
  ],
  content12: [
    {
      title: "Effective Management of Hair Fall"
    }
  ],
  content13: [
    {
      type: "list",
      content: "Types of Hair Fall We Treat",
      items: [
        "Androgenic Alopecia: Genetic hair fall in men and women.",
        "Telogen Effluvium: Hair fall due to stress or illness.",
        "Alopecia Areata: Patchy hair loss due to autoimmune conditions."
      ]
    },
    {
      type: "list1",
      content: "Key Features of Our Hair Fall Treatment",
      content1: "Our approach includes natural remedies, lifestyle guidance, and regular monitoring to ensure long-term relief.",
      items: [
        "Tailored treatment plans for hair growth.",
        "Safe and effective remedies for all age groups.",
        "Comprehensive care for scalp and hair health."
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Hair fall can be effectively managed with the right treatment and care. At H-Cura Homeopathy, we provide natural, holistic solutions to promote hair growth and improve scalp health."
    },
    {
      title: "",
      content: "Our treatments focus on addressing the root causes of hair fall, ensuring long-term relief and healthy hair. Book your consultation today and take the first step towards a confident you."
    }
  ]
},
//anxiety
{
  id: "anxiety-neurosis",
  name: "Anxiety Neurosis",
  metadata: [
    {
      title: "Best Homeopathic Treatment for Anxiety & Neurosis | H-Cura",
      description: "Natural homeopathic solutions for anxiety, panic attacks, and neurosis at H-Cura. Regain emotional balance safely. Book your consultation today.",
      keywords: "anxiety treatment, homeopathy for neurosis, panic attack relief, stress management, mental wellness",
      canonicalUrl: "https://www.h-cura.com/treatments/anxiety-neurosis",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Effective Homeopathic Treatment for Anxiety Disorders" }
  ],
  content1: [
    {
      type: "image",
      src: anxietyBanner,
      alt: "anxiety-treatment",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Anxiety & Neurosis Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Holistic Anxiety Management" }
  ],
  content3: [
    {
      type: "heading",
      content: "Anxiety Neurosis: Causes, Symptoms & Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Anxiety Disorders",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Anxiety neurosis manifests as persistent worry, panic attacks, and physical symptoms like palpitations. At H-Cura, we address both psychological triggers and physiological imbalances using remedies like Argentum Nitricum and Ignatia.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes",
      className: "treatmentinfection1",
      items: [
        "Chronic stress at work/home",
        "Genetic predisposition to anxiety",
        "Hormonal imbalances",
        "Traumatic life events",
        "Nutritional deficiencies (B12, magnesium)"
      ]
    },
    {
      type: "image-overlay",
      src: anxietyTreatment,
      alt: "anxiety-remedies",
      title: "Find Calm Naturally",
      description: "Personalized solutions for lasting mental peace",
      link: "/bookconsultation",
      buttonText: "Consult Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications",
      items: [
        "Social isolation",
        "Depression",
        "Digestive disorders"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Anxiety symptoms range from psychological distress to physical manifestations:",
      items: [
        "Racing thoughts & irrational fears",
        "Sweating palms & trembling",
        "Sleep disturbances"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis Approach",
      content1: "We assess through detailed psychological evaluation, stress hormone tests (cortisol), and analysis of lifestyle triggers to create personalized treatment plans.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: anxietyGallery1, alt: "panic-attack" },
    { src: anxietyGallery2, alt: "stress-management" },
    { src: anxietyGallery3, alt: "mind-calming" },
    { src: anxietyGallery4, alt: "emotional-balance" }
  ],
  content8: [
    {
      title1: "Our Anxiety Treatment Philosophy",
      description1: "We combine constitutional remedies with cognitive behavioral techniques to address root causes."
    }
  ],
  content9: [
    {
      icon: <FaBrain className="feature-icon1" />,
      title: "Neurotransmitter Balance",
      description: "Regulate serotonin & GABA levels naturally"
    },
    {
      icon: <FaHeartbeat className="feature-icon1" />,
      title: "Physical Symptom Relief",
      description: "Reduce palpitations & digestive issues"
    },
    {
      icon: <FaMoon className="feature-icon1" />,
      title: "Sleep Restoration",
      description: "Improve sleep quality without sedatives"
    }
  ],
  content10: [
    { title: "Why Choose H-Cura for Anxiety?" }
  ],
  content11: [
    {
      description: "Non-addictive alternatives to benzodiazepines"
    },
    {
      description: "15+ years experience in psychosomatic disorders"
    },
    {
      description: "Combined mind-body healing approach"
    }
  ],
  content12: [
    { title: "Regain Emotional Stability" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Generalized Anxiety Disorder (GAD)",
        "Social Phobia",
        "OCD-related anxiety"
      ]
    },
    {
      type: "list1",
      content: "Treatment Features",
      content1: "Safe for long-term management:",
      items: [
        "Reduced medication dependency",
        "Improved focus & productivity",
        "Enhanced social confidence"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Break free from anxiety's grip with H-Cura's holistic approach. Experience lasting calm through personalized homeopathic care."
    },
    {
      title: "",
      content: "Our natural treatments help you manage triggers effectively while improving overall mental resilience."
    }
  ]
},

//prosprostatitis
{
  id: "prostatitis",
  name: "prostatitis",
  metadata: [
    {
      title: "Prostatitis Homeopathic Treatment | H-Cura Homeopathy",
      description: "Effective homeopathic solutions for prostatitis pain, urinary issues & inflammation. Book your consultation for natural relief.",
      keywords: "prostatitis treatment, prostate inflammation, urinary pain relief, homeopathy for prostatitis, chronic pelvic pain",
      canonicalUrl: "https://www.h-cura.com/treatments/prostatitis",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Prostatitis" }
  ],
  content1: [
    {
      type: "image",
      src: prostatitisBanner,
      alt: "prostatitis-treatment",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Prostatitis Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Natural Relief from Prostate Inflammation" }
  ],
  content3: [
    {
      type: "heading",
      content: "Prostatitis: Causes, Symptoms & Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Prostate Inflammation",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Prostatitis causes pelvic pain, frequent urination, and sexual dysfunction. Our remedies like Sabal Serrulata and Chimaphila target inflammation and improve urinary flow without antibiotics.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Causes of Prostatitis",
      className: "treatmentinfection1",
      items: [
        "Bacterial infections (acute prostatitis)",
        "Chronic pelvic muscle tension",
        "Autoimmune responses",
        "Urinary tract abnormalities"
      ]
    },
    {
      type: "image-overlay",
      src: prostatitisTreatment,
      alt: "prostate-health",
      title: "Book Consultation",
      description: "Heal inflammation naturally",
      link: "/bookconsultation",
      buttonText: "Book Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications",
      items: [
        "Chronic pelvic pain syndrome",
        "Erectile dysfunction",
        "Bladder stones"
      ]
    },
    {
      type: "list1",
      content: "Symptoms",
      content1: "Common signs include:",
      items: [
        "Burning during urination",
        "Lower back/pelvic pain",
        "Cloudy urine"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis",
      content1: "We use urine cultures, prostate fluid analysis, and ultrasound to identify infection or inflammation.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: prostatitisGallery1, alt: "pelvic-pain" },
    { src: prostatitisGallery2, alt: "urinary-health" },
    { src: prostatitisGallery3, alt: "prostate-exam" },
    { src: prostatitisGallery4, alt: "inflammation-relief" }
  ],
  content8: [
    {
      title1: "Our Prostatitis Treatment Approach",
      description1: "Focus on reducing inflammation and improving urinary function with zero side effects."
    }
  ],
  content9: [
    {
      icon: <FaTint className="feature-icon1" />,
      title: "Urinary Flow Improvement",
      description: "Reduce frequency & urgency"
    },
    {
      icon: <FaLeaf className="feature-icon1" />,
      title: "Anti-Inflammatory Action",
      description: "Heal prostate tissue naturally"
    },
    {
      icon: <FaMedkit className="feature-icon1" />,
      title: "Infection Control",
      description: "Combat bacterial growth"
    }
  ],
  content10: [
    { title: "Why Choose Us?" }
  ],
  content11: [
    {
      description: "Non-antibiotic approach to chronic prostatitis"
    },
    {
      description: "12+ years of urology expertise"
    },
    {
      description: "Personalized pelvic health plans"
    }
  ],
  content12: [
    { title: "Effective Prostatitis Management" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Chronic pelvic pain syndrome",
        "Bacterial prostatitis",
        "Asymptomatic inflammatory prostatitis"
      ]
    },
    {
      type: "list1",
      content: "Treatment Benefits",
      content1: "Key advantages include:",
      items: [
        "Pain reduction within 4-6 weeks",
        "Improved sexual function",
        "Lower recurrence risk"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Break free from prostatitis discomfort with H-Cura’s safe, natural treatments. Restore prostate health holistically."
    },
    {
      title: "",
      content: "We combine homeopathy with lifestyle guidance for long-term relief."
    }
  ]
},

//sleeplessness

{
  id: "sleeplessness",
  name: "Sleeplessness",
  metadata: [
    {
      title: "Homeopathic Insomnia Treatment | Cure Sleeplessness Naturally | H-Cura",
      description: "Struggling with chronic insomnia? H-Cura Homeopathy offers safe, non-habit-forming treatments to restore healthy sleep patterns. Book a consultation today.",
      keywords: "insomnia treatment, homeopathy for sleeplessness, chronic sleep disorders, natural sleep aids, H-Cura Homeopathy",
      canonicalUrl: "https://www.h-cura.com/treatments/sleeplessness",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Chronic Sleeplessness" }
  ],
  content1: [
    {
      type: "image",
      src: sleeplessnessBanner,
      alt: "insomnia-treatment",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Sleeplessness Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Natural Homeopathic Solutions for Chronic Insomnia" }
  ],
  content3: [
    {
      type: "heading",
      content: "Sleeplessness: Causes, Symptoms, and Homeopathic Treatment at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Insomnia",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Chronic sleeplessness disrupts daily life, leading to fatigue, irritability, and poor concentration. At H-Cura, we address root causes like anxiety, hormonal imbalances, and lifestyle factors using remedies such as Coffea Cruda and Nux Vomica to restore natural sleep cycles without dependency.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes of Insomnia",
      className: "treatmentinfection1",
      items: [
        "Chronic stress or anxiety",
        "Hormonal imbalances (melatonin/cortisol)",
        "Poor sleep hygiene (screen time, irregular schedules)",
        "Underlying conditions (thyroid, GERD)",
        "Medication side effects"
      ]
    },
    {
      type: "image-overlay",
      src: insomniaTreatment,
      alt: "insomnia-remedies",
      title: "Restore Your Sleep",
      description: "Wake up refreshed with natural solutions.",
      link: "/bookconsultation",
      buttonText: "Book Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of Untreated Insomnia",
      items: [
        "Depression/anxiety disorders",
        "Weakened immunity",
        "Increased risk of heart disease"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Persistent difficulty falling/staying asleep, waking up too early, or non-restorative sleep.",
      items: [
        "Daytime fatigue and irritability",
        "Difficulty concentrating",
        "Frequent nighttime awakenings"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of Insomnia",
      content1: "We evaluate sleep patterns through detailed questionnaires, sleep diaries, and tests like polysomnography to rule out sleep apnea. Hormonal blood tests identify imbalances affecting sleep.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: sleeplessnessGallery1, alt: "insomnia-effects" },
    { src: sleeplessnessGallery2, alt: "sleep-cycle" },
    { src: sleeplessnessGallery3, alt: "stress-sleeplessness" },
    { src: sleeplessnessGallery4, alt: "natural-remedies" }
  ],
  content8: [
    {
      title1: "Homeopathic Treatment for Sleeplessness at H-Cura",
      description1: "Our remedies like Passiflora and Avena Sativa calm the nervous system, reduce anxiety, and regulate sleep-wake cycles naturally."
    }
  ],
  content9: [
    {
      icon: <FaMoon className="feature-icon1" />,
      title: "Sleep Cycle Regulation",
      description: "Restore natural circadian rhythms."
    },
    {
      icon: <FaBrain className="feature-icon1" />,
      title: "Stress Reduction",
      description: "Address anxiety triggering insomnia."
    },
    {
      icon: <FaHeartbeat className="feature-icon1" />,
      title: "Holistic Care",
      description: "Combine diet/lifestyle guidance."
    }
  ],
  content10: [
    { title: "Why Choose H-Cura for Insomnia?" }
  ],
  content11: [
    {
      description: "Non-sedative, non-addictive treatments."
    },
    {
      description: "20+ years of expertise in sleep disorders."
    },
    {
      description: "Personalized plans based on root causes."
    }
  ],
  content12: [
    { title: "Regain Restful Sleep Naturally" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Stress-induced insomnia",
        "Menopausal sleeplessness",
        "Jet lag disorder"
      ]
    },
    {
      type: "list1",
      content: "Key Benefits",
      content1: "Safe for long-term use with zero side effects.",
      items: [
        "Reduced nighttime awakenings",
        "Improved sleep quality",
        "No morning grogginess"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Don’t let sleeplessness control your life. H-Cura’s natural treatments help you achieve deep, restorative sleep sustainably."
    },
    {
      title: "",
      content: "Our remedies address hormonal imbalances, stress, and lifestyle factors for lasting results."
    }
  ]
},
//ulcerative-colitis
{
  id: "ulcerative-colitis",
  name: "Ulcerative Colitis",
  metadata: [
    {
      title: "Ulcerative Colitis Treatment | Homeopathy for UC | H-Cura",
      description: "Control UC flare-ups naturally with H-Cura’s homeopathy. Reduce inflammation, heal the gut, and achieve remission. Consult our experts today.",
      keywords: "ulcerative colitis treatment, homeopathy for UC, IBD management, natural colitis care, H-Cura Homeopathy",
      canonicalUrl: "https://www.h-cura.com/treatments/ulcerative-colitis",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Ulcerative Colitis" }
  ],
  content1: [
    {
      type: "image",
      src: colitisBanner,
      alt: "uc-treatment",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Ulcerative Colitis Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Natural Relief for Chronic Colitis" }
  ],
  content3: [
    {
      type: "heading",
      content: "Ulcerative Colitis: Causes, Symptoms, and Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding UC",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Ulcerative colitis causes inflammation and ulcers in the colon, leading to abdominal pain, bloody diarrhea, and fatigue. Our remedies like Merc Sol and Argentum Nitricum reduce inflammation, heal mucosal lining, and prevent flare-ups.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes of UC",
      className: "treatmentinfection1",
      items: [
        "Autoimmune dysfunction",
        "Genetic predisposition",
        "Gut microbiome imbalance",
        "Chronic stress",
        "Food sensitivities"
      ]
    },
    {
      type: "image-overlay",
      src: colitisTreatment,
      alt: "colitis-remedies",
      title: "Heal Your Gut",
      description: "Achieve remission without steroids.",
      link: "/bookconsultation",
      buttonText: "Consult Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of UC",
      items: [
        "Colon perforation",
        "Severe anemia",
        "Toxic megacolon"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Frequent loose stools with blood/mucus, urgency, and tenesmus.",
      items: [
        "Abdominal cramping",
        "Unintended weight loss",
        "Fatigue and joint pain"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of UC",
      content1: "We use colonoscopy, stool tests, and blood work (CRP, ESR) to confirm inflammation. Calprotectin tests differentiate UC from IBS.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: colitisGallery1, alt: "colon-inflammation" },
    { src: colitisGallery2, alt: "uc-symptoms" },
    { src: colitisGallery3, alt: "gut-health" },
    { src: colitisGallery4, alt: "natural-remedies" }
  ],
  content8: [
    {
      title1: "Our UC Treatment Approach",
      description1: "Homeopathy heals the intestinal lining, reduces bleeding, and regulates bowel movements using remedies like Aloe Socotrina and Phosphorus."
    }
  ],
  content9: [
    {
      icon: <FaLeaf className="feature-icon1" />,
      title: "Reduce Inflammation",
      description: "Soothe mucosal ulcers naturally."
    },
    {
      icon: <FaRegHeart className="feature-icon1" />,
      title: "Prevent Flare-Ups",
      description: "Identify and eliminate triggers."
    },
    {
      icon: <FaCapsules className="feature-icon1" />,
      title: "Steroid-Free Care",
      description: "Avoid dependency on immunosuppressants."
    }
  ],
  content10: [
    { title: "Why H-Cura for UC?" }
  ],
  content11: [
    {
      description: "80% success rate in reducing flare frequency."
    },
    {
      description: "Personalized diet plans to support gut healing."
    },
    {
      description: "Zero side effects, safe for long-term use."
    }
  ],
  content12: [
    { title: "Achieve Sustainable Remission" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Proctitis (rectal inflammation)",
        "Left-sided colitis",
        "Pancolitis"
      ]
    },
    {
      type: "list1",
      content: "Key Benefits",
      content1: "Addresses autoimmune triggers holistically.",
      items: [
        "Reduced bleeding/diarrhea",
        "Improved energy levels",
        "Lowered cancer risk"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Regain control over UC with H-Cura’s natural approach. Heal your gut, reduce inflammation, and live flare-free."
    },
    {
      title: "",
      content: "Our treatments focus on long-term remission through immune modulation and lifestyle adjustments."
    }
  ]
},
//piles
{
  id: "piles",
  name: "Piles",
  metadata: [
    {
      title: "Piles Treatment | Painless Hemorrhoid Care | H-Cura Homeopathy",
      description: "Get relief from painful piles with H-Cura’s homeopathic treatment. Shrink hemorrhoids naturally without surgery. Book a consultation now.",
      keywords: "piles treatment, homeopathy for hemorrhoids, painless piles care, bleeding piles relief, H-Cura Homeopathy",
      canonicalUrl: "https://www.h-cura.com/treatments/piles",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Piles" }
  ],
  content1: [
    {
      type: "image",
      src: pilesBanner,
      alt: "hemorrhoid-treatment",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Piles Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Non-Surgical Relief for Hemorrhoids" }
  ],
  content3: [
    {
      type: "heading",
      content: "Piles: Causes, Symptoms, and Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Hemorrhoids",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Piles (swollen rectal veins) cause pain, itching, and bleeding during bowel movements. Our remedies like Hamamelis and Aesculus reduce swelling, heal fissures, and prevent recurrence without invasive procedures.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes of Piles",
      className: "treatmentinfection1",
      items: [
        "Chronic constipation",
        "Pregnancy/childbirth",
        "Sedentary lifestyle",
        "Obesity",
        "Low-fiber diet"
      ]
    },
    {
      type: "image-overlay",
      src: pilesTreatment,
      alt: "piles-remedies",
      title: "End the Pain",
      description: "Shrink hemorrhoids naturally.",
      link: "/bookconsultation",
      buttonText: "Book Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications of Piles",
      items: [
        "Thrombosed hemorrhoids",
        "Anemia from chronic bleeding",
        "Anal fistula"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Painful lumps near the anus, bright red blood on stool or toilet paper.",
      items: [
        "Itching/irritation",
        "Mucus discharge",
        "Difficulty sitting"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis of Piles",
      content1: "We perform a digital rectal exam and proctoscopy to grade hemorrhoids (I-IV). Rule out colorectal cancer with colonoscopy if needed.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: pilesGallery1, alt: "hemorrhoid-grades" },
    { src: pilesGallery2, alt: "piles-symptoms" },
    { src: pilesGallery3, alt: "rectal-health" },
    { src: pilesGallery4, alt: "natural-treatment" }
  ],
  content8: [
    {
      title1: "Homeopathic Treatment for Piles at H-Cura",
      description1: "Remedies like Aloe Socotrina and Nux Vomica relieve constipation, reduce vein swelling, and promote healing of fissures."
    }
  ],
  content9: [
    {
      icon: <FaSyringe className="feature-icon1" />,
      title: "No Surgery Needed",
      description: "Shrink piles naturally."
    },
    {
      icon: <FaLeaf className="feature-icon1" />,
      title: "Pain Relief",
      description: "Soothe burning/itching."
    },
    {
      icon: <FaRegClock className="feature-icon1" />,
      title: "Quick Recovery",
      description: "Reduce bleeding in 2-4 weeks."
    }
  ],
  content10: [
    { title: "Why Choose Us for Piles?" }
  ],
  content11: [
    {
      description: "90% success rate in Grade I-III piles."
    },
    {
      description: "Avoid risky surgeries."
    },
    {
      description: "Personalized diet plans to prevent recurrence."
    }
  ],
  content12: [
    { title: "Regain Comfort and Confidence" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Internal hemorrhoids",
        "External hemorrhoids",
        "Thrombosed piles"
      ]
    },
    {
      type: "list1",
      content: "Key Benefits",
      content1: "Safe for pregnant women and seniors.",
      items: [
        "Reduced swelling/pain",
        "Healed anal fissures",
        "Improved bowel movements"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Don’t suffer silently from piles. H-Cura’s natural treatments provide lasting relief and prevent recurrence."
    },
    {
      title: "",
      content: "Our remedies address constipation, vein health, and inflammation holistically."
    }
  ]
},
//infertility
{
  id: "infertility",
  name: "Infertility",
  metadata: [
    {
      title: "Homeopathic Infertility Treatment | Natural Conception Solutions | H-Cura",
      description: "Safe and effective homeopathic treatment for infertility at H-Cura. Address hormonal imbalances, ovulation issues, and improve fertility naturally. Book a consultation today.",
      keywords: "infertility treatment, homeopathy for conception, natural fertility solutions, H-Cura Homeopathy, hormonal balance",
      canonicalUrl: "https://www.h-cura.com/treatments/infertility",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Infertility" }
  ],
  content1: [
    {
      type: "image",
      src: infertilityBanner,
      alt: "infertility-treatment",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Infertility Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Natural Solutions for Conception" }
  ],
  content3: [
    {
      type: "heading",
      content: "Infertility: Causes, Diagnosis, and Homeopathic Solutions at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Infertility",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Infertility affects 1 in 6 couples globally, with causes ranging from hormonal imbalances and ovulation disorders to low sperm count. At H-Cura, we address both male and female infertility through remedies that improve reproductive health without side effects.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes",
      className: "treatmentinfection1",
      items: [
        "Hormonal imbalances (PCOS, thyroid disorders)",
        "Blocked fallopian tubes",
        "Low sperm motility/count",
        "Endometriosis",
        "Stress & lifestyle factors"
      ]
    },
    {
      type: "image-overlay",
      src: infertilityTreatment,
      alt: "infertility-care",
      title: "Start Your Parenthood Journey",
      description: "Safe, natural approaches to enhance fertility.",
      link: "/bookconsultation",
      buttonText: "Consult Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications",
      items: [
        "Emotional stress & relationship strain",
        "Financial burden of IVF/ICSI",
        "Increased miscarriage risk"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Inability to conceive after 1 year of trying (6 months if over 35). Other signs include irregular periods, painful intercourse, or recurrent pregnancy loss.",
      items: [
        "Irregular menstrual cycles",
        "Low libido",
        "Erectile dysfunction in men"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis",
      content1: "We conduct hormone profiling (FSH, LH, AMH), semen analysis, ultrasound for ovarian reserve, and laparoscopy for structural issues. Homeopathic case-taking identifies emotional/mental blocks affecting fertility.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: infertilityGallery1, alt: "fertility-test" },
    { src: infertilityGallery2, alt: "ovulation-tracking" },
    { src: infertilityGallery3, alt: "sperm-analysis" },
    { src: infertilityGallery4, alt: "happy-couple" }
  ],
  content8: [
    {
      title1: "Homeopathic Fertility Treatment at H-Cura",
      description1: "Remedies like Sepia, Lycopodium, and Pulsatilla regulate hormones, improve egg/sperm quality, and reduce stress-related infertility."
    }
  ],
  content9: [
    {
      icon: <FaBaby className="feature-icon1" />,
      title: "Hormonal Balance",
      description: "Regulate menstrual cycles and ovulation"
    },
    {
      icon: <FaHeartbeat className="feature-icon1" />,
      title: "Sperm Health",
      description: "Improve motility and count naturally"
    },
    {
      icon: <FaCalendarCheck className="feature-icon1" />,
      title: "Cycle Tracking",
      description: "Personalized ovulation support"
    }
  ],
  content10: [
    { title: "Why Choose Us for Infertility?" }
  ],
  content11: [
    {
      description: "45% success rate in natural conception within 12 months"
    },
    {
      description: "Combines homeopathy with dietary guidance"
    },
    {
      description: "Treats unexplained infertility cases"
    }
  ],
  content12: [
    { title: "Holistic Fertility Management" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Female infertility (PCOS, endometriosis)",
        "Male infertility (oligospermia)",
        "Unexplained infertility"
      ]
    },
    {
      type: "list1",
      content: "Key Benefits",
      content1: "Non-invasive with zero interference in IVF cycles",
      items: [
        "Reduced IVF failure rates",
        "Improved endometrial thickness",
        "Lower miscarriage risk"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Infertility can be overcome with the right approach. H-Cura’s natural treatments enhance your body’s innate ability to conceive and sustain pregnancy."
    },
    {
      title: "",
      content: "We address physical, emotional, and lifestyle factors for comprehensive fertility care."
    }
  ]
},
//varicose

{
  id: "varicose",
  name: "Varicose",
  metadata: [
    {
      title: "Varicose Veins Treatment | Homeopathy for Leg Pain | H-Cura",
      description: "Effective homeopathic treatment for varicose veins at H-Cura. Reduce swelling, pain, and improve blood circulation naturally. Consult our experts today.",
      keywords: "varicose veins treatment, spider veins, homeopathy for leg veins, chronic venous insufficiency, H-Cura",
      canonicalUrl: "https://www.h-cura.com/treatments/varicose",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Treatment for Varicose Veins" }
  ],
  content1: [
    {
      type: "image",
      src: varicoseBanner,
      alt: "varicose-veins",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Varicose Veins Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Relief from Leg Pain & Swelling" }
  ],
  content3: [
    {
      type: "heading",
      content: "Varicose Veins: Causes, Symptoms, and Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Venous Insufficiency",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Varicose veins occur when weakened valves allow blood to pool in leg veins, causing bulging veins, pain, and skin changes. Our treatments strengthen venous walls and improve circulation without surgery.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes",
      className: "treatmentinfection1",
      items: [
        "Prolonged standing/sitting",
        "Obesity",
        "Pregnancy",
        "Genetic predisposition",
        "Deep vein thrombosis history"
      ]
    },
    {
      type: "image-overlay",
      src: varicoseTreatment,
      alt: "vein-treatment",
      title: "Heal Your Legs Naturally",
      description: "Reduce bulging veins and discomfort",
      link: "/bookconsultation",
      buttonText: "Book Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications",
      items: [
        "Venous ulcers",
        "Bleeding veins",
        "Deep vein thrombosis (DVT)"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Twisted, bulging veins accompanied by heaviness, itching, or cramping.",
      items: [
        "Swollen ankles",
        "Skin discoloration",
        "Worsening pain after standing"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis",
      content1: "We use Doppler ultrasound to assess blood flow and identify faulty valves. Physical exams check for edema, skin changes, and vein elasticity.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: varicoseGallery1, alt: "bulging-veins" },
    { src: varicoseGallery2, alt: "leg-ulcer" },
    { src: varicoseGallery3, alt: "doppler-scan" },
    { src: varicoseGallery4, alt: "compression-therapy" }
  ],
  content8: [
    {
      title1: "Our Varicose Veins Treatment Approach",
      description1: "Remedies like Hamamelis, Pulsatilla, and Calcarea Fluor reduce inflammation and improve venous tone."
    }
  ],
  content9: [
    {
      icon: <FaTint className="feature-icon1" />,
      title: "Improve Circulation",
      description: "Enhance blood return to heart"
    },
    {
      icon: <FaCompress className="feature-icon1" />,
      title: "Reduce Swelling",
      description: "Alleviate edema and heaviness"
    },
    {
      icon: < FaSpa  className="feature-icon1" />,
      title: "Prevent Ulcers",
      description: "Heal skin changes naturally"
    }
  ],
  content10: [
    { title: "Why H-Cura for Varicose Veins?" }
  ],
  content11: [
    {
      description: "Avoid surgery with our non-invasive protocols"
    },
    {
      description: "Personalized exercise/diet plans"
    },
    {
      description: "15+ years of vein disorder expertise"
    }
  ],
  content12: [
    { title: "Comprehensive Vein Health" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Spider veins",
        "Chronic venous insufficiency",
        "Post-thrombotic syndrome"
      ]
    },
    {
      type: "list1",
      content: "Key Features",
      content1: "Combines remedies with lifestyle modifications",
      items: [
        "Reduced vein visibility",
        "Improved leg stamina",
        "Prevention of recurrence"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Varicose veins don’t have to limit your mobility. H-Cura’s natural treatments help you regain pain-free legs and prevent complications."
    },
    {
      title: "",
      content: "Our holistic approach addresses both symptoms and underlying circulatory issues."
    }
  ]
},

//tyroid
{
  id: "thyroid",
  name: "thyroid",
  metadata: [
    {
      title: "Thyroid Disorder Treatment | Homeopathy for Hypothyroidism | H-Cura",
      description: "Effective homeopathic treatment for thyroid disorders at H-Cura. Balance TSH levels naturally and manage Hashimoto’s. Book your consultation today.",
      keywords: "thyroid treatment, homeopathy for hypothyroidism, Hashimoto’s disease, natural TSH balance, H-Cura",
      canonicalUrl: "https://www.h-cura.com/treatments/thyroid",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic Thyroid Treatment" }
  ],
  content1: [
    {
      type: "image",
      src: thyroidBanner,
      alt: "thyroid-gland",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Thyroid Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Natural TSH Regulation" }
  ],
  content3: [
    {
      type: "heading",
      content: "Thyroid Disorders: Causes, Symptoms, and Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Thyroid Imbalance",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "The thyroid gland regulates metabolism, energy, and growth. Hypothyroidism (underactive) and hyperthyroidism (overactive) cause weight fluctuations, fatigue, and mood disorders. Our remedies restore hormonal harmony.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes",
      className: "treatmentinfection1",
      items: [
        "Autoimmune disorders (Hashimoto’s/Graves’)",
        "Iodine deficiency",
        "Pituitary gland dysfunction",
        "Radiation exposure",
        "Genetic factors"
      ]
    },
    {
      type: "image-overlay",
      src: thyroidTreatment,
      alt: "thyroid-care",
      title: "Balance Your Hormones",
      description: "Natural solutions for thyroid health",
      link: "/bookconsultation",
      buttonText: "Consult Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications",
      items: [
        "Heart disease",
        "Infertility",
        "Myxedema coma (severe hypothyroidism)"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Hypothyroidism: Weight gain, fatigue, cold intolerance. Hyperthyroidism: Weight loss, palpitations, heat sensitivity.",
      items: [
        "Hair loss",
        "Dry skin",
        "Muscle weakness",
        "Anxiety/Depression"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis",
      content1: "We analyze TSH, Free T3/T4 levels, thyroid antibodies (anti-TPO), and ultrasound scans to identify nodules or inflammation.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: thyroidGallery1, alt: "thyroid-ultrasound" },
    { src: thyroidGallery2, alt: "goiter" },
    { src: thyroidGallery3, alt: "weight-gain" },
    { src: thyroidGallery4, alt: "thyroid-nodules" }
  ],
  content8: [
    {
      title1: "Homeopathic Thyroid Treatment at H-Cura",
      description1: "Remedies like Thyroidinum, Calcarea Carb, and Iodum regulate hormone production and reduce antibody levels."
    }
  ],
  content9: [
    {
      icon: <FaBalanceScale className="feature-icon1" />,
      title: "TSH Balance",
      description: "Normalize thyroid hormone levels"
    },
    {
      icon: <FaBolt className="feature-icon1" />,
      title: "Boost Energy",
      description: "Combat fatigue and brain fog"
    },
    {
      icon: <FaShieldAlt className="feature-icon1" />,
      title: "Autoimmune Support",
      description: "Manage Hashimoto’s effectively"
    }
  ],
  content10: [
    { title: "Why Choose Us for Thyroid Care?" }
  ],
  content11: [
    {
      description: "60% reduction in thyroid medication dependency"
    },
    {
      description: "Address root causes, not just symptoms"
    },
    {
      description: "Personalized diet plans (gluten-free/iodine-rich)"
    }
  ],
  content12: [
    { title: "Holistic Thyroid Management" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Hypothyroidism",
        "Hyperthyroidism",
        "Thyroid nodules"
      ]
    },
    {
      type: "list1",
      content: "Key Benefits",
      content1: "Safe for long-term use alongside conventional meds",
      items: [
        "Reduced antibody levels",
        "Improved metabolic rate",
        "Healthier hair/skin"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Thyroid disorders require comprehensive care. H-Cura’s natural treatments help you achieve hormonal balance and reclaim your vitality."
    },
    {
      title: "",
      content: "We focus on sustainable thyroid health through immune modulation and lifestyle guidance."
    }
  ]
},
//gerd
{
  id: "gerd",
  name: "gerd",
  metadata: [
    {
      title: "GERD & Acid Reflux Treatment | Homeopathy for Heartburn | H-Cura",
      description: "Effective homeopathic treatment for GERD at H-Cura. Relieve heartburn, acid reflux, and heal esophageal damage naturally. Book consultation now.",
      keywords: "GERD treatment, homeopathy for acid reflux, natural heartburn relief, hiatal hernia care, H-Cura",
      canonicalUrl: "https://www.h-cura.com/treatments/best gerd treatment",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", content: "Best Homeopathic GERD Treatment" }
  ],
  content1: [
    {
      type: "image",
      src: gerdBanner,
      alt: "acid-reflux",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "GERD Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", content: "Natural Relief from Acid Reflux" }
  ],
  content3: [
    {
      type: "heading",
      content: "GERD: Causes, Symptoms, and Homeopathic Care at H-Cura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Acid Reflux",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Gastroesophageal Reflux Disease (GERD) occurs when stomach acid frequently flows back into the esophagus, causing heartburn and tissue damage. Our treatments strengthen the lower esophageal sphincter and reduce acid production.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Common Causes",
      className: "treatmentinfection1",
      items: [
        "Hiatal hernia",
        "Obesity",
        "Smoking/alcohol",
        "Spicy/fatty diets",
        "Pregnancy"
      ]
    },
    {
      type: "image-overlay",
      src: gerdTreatment,
      alt: "gerd-care",
      title: "Heal Your Digestion",
      description: "End heartburn naturally",
      link: "/bookconsultation",
      buttonText: "Book Now"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Complications",
      items: [
        "Esophageal ulcers",
        "Barrett’s esophagus",
        "Dental erosion"
      ]
    },
    {
      type: "list1",
      content: "Key Symptoms",
      content1: "Burning chest pain, regurgitation, and chronic cough worse at night.",
      items: [
        "Sour taste in mouth",
        "Difficulty swallowing",
        "Hoarseness"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis",
      content1: "We use endoscopy to assess esophageal damage, pH monitoring to measure acid levels, and manometry to evaluate sphincter function.",
      className: "treatmentDiagnosis"
    }
  ],
  content7: [
    { src: gerdGallery1, alt: "endoscopy" },
    { src: gerdGallery2, alt: "heartburn" },
    { src: gerdGallery3, alt: "diet-plan" },
    { src: gerdGallery4, alt: "happy-patient" }
  ],
  content8: [
    {
      title1: "Homeopathic GERD Treatment at H-Cura",
      description1: "Remedies like Robinia, Carbo Veg, and Nux Vomica neutralize acid and improve digestive function."
    }
  ],
  content9: [
    {
      icon: <FaFireExtinguisher className="feature-icon1" />,
      title: "Reduce Acidity",
      description: "Soothe burning sensation"
    },
    {
      icon: <FaRegCircle className="feature-icon1" />,
      title: "Heal Esophagus",
      description: "Repair damaged tissues"
    },
    {
      icon: <FaUtensils className="feature-icon1" />,
      title: "Diet Plans",
      description: "Trigger-food avoidance guidance"
    }
  ],
  content10: [
    { title: "Why Choose Us for GERD?" }
  ],
  content11: [
    {
      description: "70% reduction in PPIs dependency"
    },
    {
      description: "Address root causes like stress/hiatal hernia"
    },
    {
      description: "15+ years of GI disorder expertise"
    }
  ],
  content12: [
    { title: "Complete Digestive Wellness" }
  ],
  content13: [
    {
      type: "list",
      content: "Types We Treat",
      items: [
        "Chronic acid reflux",
        "LPR (silent reflux)",
        "Post-meal bloating"
      ]
    },
    {
      type: "list1",
      content: "Key Features",
      content1: "Combines remedies with posture/dietary advice",
      items: [
        "Reduced nighttime symptoms",
        "Improved digestion",
        "Prevention of Barrett’s esophagus"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "GERD can be managed effectively without lifelong medications. H-Cura’s natural approach heals your gut and restores digestive comfort."
    },
    {
      title: "",
      content: "We focus on long-term relief through sphincter strengthening and lifestyle modifications."
    }
  ]
},
//mellnoma
{
  id: "melanoma",
  name: "melanoma",
  metadata: [
    {
      title: "Melanoma Treatment | H-Cura Homeopathy",
      description: "Expert homeopathic care for melanoma at H-Cura. Safe, natural treatments targeting root causes. Book consultation for personalized skin cancer care.",
      keywords: "Melanoma treatment, Homeopathy for skin cancer, H-Cura melanoma care, Natural skin cancer remedies",
      canonicalUrl: "https://www.h-cura.com/treatments/melanoma",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type :"heading", "content": "Best Homeopathic Melanoma Treatment" }
  ],
  content1: [
    {
      type: "image",
      src: melanoma,
      alt: "melanoma-image1",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Melanoma Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", "content": "Advanced Homeopathic Melanoma Care" }
  ],
  content3: [
    {
      type: "heading",
      content: "Melanoma: Understanding, Risk Factors, Symptoms and Homeopathic Approach at HCura",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Melanoma",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Melanoma is the most serious type of skin cancer developing in melanocytes. While less common than other skin cancers, it's more likely to spread if not treated early. Early detection through ABCDE rule (Asymmetry, Border irregularity, Color variation, Diameter >6mm, Evolution) is crucial for successful outcomes. Our approach focuses on supporting conventional care while managing symptoms naturally.",
      className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Key Risk Factors",
      className: "treatmentinfection1",
      items: [
        "Intense UV exposure from sun/sunbeds",
        "Fair skin with history of sunburns",
        "Family history of melanoma",
        "Presence of dysplastic nevi",
        "Weakened immune system"
      ]
    },
    {
      type: "image-overlay",
      src: melanomatreatment,
      alt: "Melanoma Assessment",
      title: "Early Detection Saves Lives",
      description: "Professional evaluation of suspicious moles",
      link: "/bookconsultation",
      buttonText: "Get Mole Checked"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Potential Complications",
      items: [
        "Metastasis to other organs",
        "Lymph node involvement",
        "Recurrence after treatment",
        "Treatment side effects"
      ]
    },
    {
      type: "list1",
      content: "Warning Signs",
      content1: "Early detection is crucial. Watch for:",
      items: [
        "New mole with irregular borders",
        "Existing mole changing color/size",
        "Itching/bleeding in mole",
        "Dark spot under nail"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis Approach",
      content1: "Our diagnostic protocol includes full-body photography, dermoscopic analysis, and biopsy coordination with dermatologists. We combine clinical assessment with constitutional homeopathic evaluation to create personalized care plans."
    }
  ],
  content7: [
    { src: melanoma1, alt: "melanoma" },
    { src: melanoma2, alt: "melanoma" },
    { src: melanoma3, alt: "melanoma" },
    { src: melanoma4, alt: "melanoma" }
  ],
  content8: [
    {
      title1: "Homeopathic Melanoma Management",
      description1: "Our complementary approach focuses on enhancing conventional treatments, managing side effects, and supporting overall immunity through natural remedies."
    }
  ],
  content9: [
    {
      icon: "<FaShieldAlt className='feature-icon1' />",
      title: "Immune Support",
      description: "Enhance body's natural defense mechanisms"
    },
    {
      icon: "<FaRegClock className='feature-icon1' />",
      title: "Symptom Management",
      description: "Address treatment-related fatigue/nausea"
    },
    {
      icon: "<FaHeartbeat className='feature-icon1' />",
      title: "Holistic Care",
      description: "Support physical and emotional wellbeing"
    }
  ],
  content10: [
    { title: "Why Choose Us for Melanoma Care?" }
  ],
  content11: [
    { description: "Integrative approach combining medical best practices with natural healing" },
    { description: "20+ years experience in complementary cancer care" },
    { description: "Personalized plans respecting individual treatment journeys" }
  ],
  content12: [
    { title: "Comprehensive Melanoma Support" }
  ],
  content13: [
    {
      type: "list",
      content: "Our Services Include",
      items: [
        "Adjuvant therapy support",
        "Post-treatment recovery plans",
        "Preventive care for high-risk patients",
        "Lymphatic system support"
      ]
    },
    {
      type: "list1",
      content: "Treatment Features",
      content1: "Non-invasive solutions complementing conventional oncology",
      items: [
        "Zero chemical interference",
        "Gentle symptom management",
        "Emotional wellbeing support",
        "Customized nutritional guidance"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "While melanoma requires medical attention, homeopathy offers valuable supportive care. At H-Cura, we provide safe adjunct therapies to enhance treatment outcomes and quality of life."
    },
    {
      title: "",
      content: "Our holistic approach addresses both physical symptoms and emotional challenges of cancer journey. Partner with us for comprehensive melanoma management."
    }
  ]
},
//acne
{
  id: "acne",
  name: "Acne",
  metadata: [
    {
      title: "Acne Treatment | H-Cura Homeopathy",
      description: "Effective homeopathic solutions for acne at H-Cura. Treat root causes of pimples, cysts & scarring. Book consultation for clear skin naturally.",
      keywords: "Acne treatment, Homeopathy for pimples, Cystic acne cure, Natural acne remedies",
      canonicalUrl: "https://www.h-cura.com/treatments/acne",
      favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
    { type: "heading", "content": "Holistic Homeopathic Acne Treatment" }
  ],
  content1: [
    {
      type: "image",
      src: acne,
      alt: "acne-banner",
      className: "treatment-banner"
    },
    {
      type: "text",
      content: "Acne Treatment",
      className: "treatment-text"
    },
    {
      type: "link",
      to: "/bookconsultation",
      buttonText: "Book Appointment",
      className: "book-appointment-button"
    }
  ],
  content2: [
    { type: "heading", "content": "Personalized Acne Solutions" }
  ],
  content3: [
    {
      type: "heading",
      content: "Acne: Causes, Types, and Homeopathic Cure at HCura Homeopathy Clinic",
      className: "treatmentprecautions"
    },
    {
      type: "subheading",
      content: "Understanding Acne",
      className: "treatmentprecautions"
    },
    {
      type: "paragraph",
      content: "Acne is a chronic skin condition characterized by pimples, blackheads, and inflammation. It commonly affects teenagers but can persist into adulthood. From mild comedones to severe cystic acne, our treatment addresses all forms while preventing permanent scarring.",
    className: "treatmentprecautions"
    }
  ],
  content4: [
    {
      type: "list",
      content: "Primary Causes",
      className: "treatmentinfection1",
      items: [
        "Hormonal imbalances during puberty/menstruation",
        "Excess sebum production",
        "Bacterial overgrowth (C. acnes)",
        "Clogged hair follicles",
        "Stress and dietary factors"
      ]
    },
    {
      type: "image-overlay",
      src: acnetreatment,
      alt: "Acne Types",
      title: "Clear Skin Journey",
      description: "Customized plans for all acne types",
      link: "/bookconsultation",
      buttonText: "Start Treatment"
    }
  ],
  content5: [
    {
      type: "list",
      content: "Potential Complications",
      items: [
        "Permanent scarring",
        "Hyperpigmentation",
        "Psychological distress",
        "Secondary infections"
      ]
    },
    {
      type: "list1",
      content: "Common Symptoms",
      content1: "Acne manifests differently across individuals:",
      items: [
        "Tender red papules/pustules",
        "Painful cystic nodules",
        "Blackheads/whiteheads",
        "Oily skin texture"
      ]
    }
  ],
  content6: [
    {
      type: "paragraph",
      content: "Diagnosis Approach",
      content1: "Our acne assessment includes detailed analysis of lesion types, hormonal patterns, and lifestyle factors. We differentiate between inflammatory/non-inflammatory acne and identify triggers through:"
    }
  ],
  content7: [
    { src: acnegallery1, alt: "acne" },
    { src: acnegallery2, alt: "acne" },
    { src: acnegallery3, alt: "acne" },
    { src: acnegallery4, alt: "acne" }
  ],
  content8: [
    {
      title1: "Homeopathic Acne Management",
      description1: "Our treatment focuses on regulating oil production, reducing inflammation, and preventing recurrence through constitutional remedies."
    }
  ],
  content9: [
    {
      icon: "<FaBalanceScale className='feature-icon1' />",
      title: "Hormonal Balance",
      description: "Regulate androgen activity naturally"
    },
    {
      icon: "<FaBacteria className='feature-icon1' />",
      title: "Antibacterial Action",
      description: "Control C. acnes growth"
    },
    {
      icon: "<FaRegClock className='feature-icon1' />",
      title: "Scar Prevention",
      description: "Early intervention for clear skin"
    }
  ],
  content10: [
    { title: "Why HCura for Acne?" }
  ],
  content11: [
    { description: "80% success rate in moderate-severe acne cases" },
    { description: "Zero side effects unlike conventional antibiotics" },
    { description: "Personalized diet/skincare guidance" }
  ],
  content12: [
    { title: "Complete Acne Care" }
  ],
  content13: [
    {
      type: "list",
      content: "We Treat All Types",
      items: [
        "Hormonal acne along jawline",
        "Cystic acne on back/chest",
        "Teenage acne vulgaris",
        "Adult-onset acne"
      ]
    },
    {
      type: "list1",
      content: "Treatment Features",
      content1: "Holistic approach combining internal remedies with topical care",
      items: [
        "No skin drying agents",
        "Gentle comedone removal",
        "Post-acne mark treatment",
        "Maintenance therapy"
      ]
    }
  ],
  content14: [
    {
      title: "Conclusion",
      content: "Acne doesn't have to control your life. At H-Cura, we offer science-backed homeopathic solutions that address both symptoms and root causes."
    },
    {
      title: "",
      content: "Our 360° approach ensures lasting results without compromising skin health. Begin your journey to clear skin today."
    }
  ]
},
//dermatitis
{
  id: "dermatitis",
  name: "dermatitis",
  metadata: [
    {
    title: "Dermatitis Treatment | H-Cura Homeopathy",
    description: "Effective homeopathic treatment for all dermatitis types - contact, atopic, seborrheic. Soothe inflamed skin naturally. Consult our experts now.",
    keywords: "Dermatitis treatment, Homeopathy for eczema, Contact dermatitis cure, Natural anti-inflammatory solutions",
    canonicalUrl: "https://www.h-cura.com/treatments/dermatitis",
    favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
      { type: "heading", content: "Best Homeopathic Dermatitis Treatment" },
  ],
  content1: [
      {
          type: "image",
          src: dermatitis,
          alt: "dermatitis-image1",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "Dermatitis Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2:[
      { type: "heading", content: "Best Homeopathic Dermatitis Treatment" },
  ],
  content3: [
      {
          type: "heading",
          content: "Dermatitis: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Dermatitis",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: "Dermatitis is an inflammatory skin condition causing redness, itching, and rashes. It manifests in various forms including contact dermatitis (triggered by irritants/allergens), atopic dermatitis (chronic eczema), and seborrheic dermatitis (affecting oily areas). Our treatment addresses both acute flare-ups and chronic cases across all age groups.",
          className: "treatmentprecautions",
      },
  ],
  content4:[
      {
        type: "list",
        content: "Causes of Dermatitis",
        className: "treatmentinfection1",
        items: [
          "Immune System Dysfunction: Overactive immune responses to triggers",
          "Chemical Irritants: Soaps, detergents, and industrial chemicals",
          "Environmental Allergens: Pollen, dust mites, and animal dander",
          "Genetic Factors: Family history of eczema/allergies",
          "Stress Triggers: Emotional stress worsening inflammation"
        ],
      },
      {
        type: "image-overlay",
        src: dermatitistreatment,
        alt: "Dermatitis Care Image",
        title: "Book an Appointment",
        description: "Personalized solutions for inflamed skin",
        link: "/bookconsultation",
        buttonText: "Book Appointment", 
      }
  ],
  content5:[
      {
          type: "list",
          content: "Complications of Dermatitis",
          items: [
            "Secondary infections from excessive scratching",
            "Lichenification (thickened leathery skin)",
            "Sleep disruption due to chronic itching",
            "Social anxiety from visible rashes"
          ],
      },
      {
          type: "list1",
          content: "Symptoms of Dermatitis",
          content1: "Dermatitis presents with various symptoms depending on type and severity:",
          items: [
            "Intense itching that worsens at night",
            "Red or grayish-brown patches on skin",
            "Small raised bumps that may leak fluid",
            "Scaly/cracked skin in chronic cases"
          ],
      }
  ],
  content6:[
      {
        type: "paragraph",
        content: "Diagnosis of Dermatitis",
        content1: "At H-Cura Homeopathy, we use a three-step diagnostic approach: 1) Detailed patient history to identify triggers 2) Physical examination of rash patterns 3) Patch testing for allergic reactions. This helps differentiate between contact, atopic, and other dermatitis types for precise treatment planning.",
        className: "treatmentDiagnosis"
      },
  ],
  content7:[
      { src: dermatitis1, alt: "dermatitis" },
      { src: dermatitis2, alt: "dermatitis" },
      { src: dermatitis3, alt: "dermatitis" },
      { src: dermatitis4, alt: "dermatitis" }
  ],
  content8:[
      {
          title1: "Homeopathic Treatment for Dermatitis at H-Cura",
          description1: "Our therapies focus on calming immune overreactions while promoting skin healing. Treatment helps reduce steroid dependency and prevents recurrence through natural solutions.",
      }
  ],
  content9:[
      {
          icon: <FaAllergies className="feature-icon1" />,
          title: "Allergy Management",
          description: "Reduce sensitivity to triggers"
      },
      {
          icon: <FaRegSmile className="feature-icon1" />,
          title: "Barrier Repair",
          description: "Strengthen skin's protective layer"
      },
      {
          icon: <FaRegClock className="feature-icon1" />,
          title: "Long-Term Relief",
          description: "Prevent chronic flare-ups"
      }
  ],
  content10:[
      {
          title: "Why Choose H-Cura Homeopathy for Dermatitis Treatment?",
      },
  ],
  content11:[
      {
          description: "60+ years combined experience in inflammatory skin conditions",
      },
      {
          description: "Customized plans for different dermatitis types",
      },
      {
          description: "Safe for infants and sensitive skin patients",
      },
  ],
  content12:[
      {
          title: "Effective Dermatitis Management",
      },
  ],
  content13:[
      {
          type: "list",
          content: "Types We Treat",
          items: [
            "Hand dermatitis: Common in healthcare/cleaning professionals",
            "Nummular dermatitis: Coin-shaped itchy patches",
            "Perioral dermatitis: Around-mouth inflammation",
            "Diaper dermatitis: Baby rash care"
          ],
      },
      {
          type: "list1",
          content: "Treatment Features",
          content1: "Our holistic approach combines internal remedies with topical care:",
          items: [
            "Chemical-free moisturizing solutions",
            "Stress-reduction protocols",
            "Dietary modification guidance",
            "Preventive care strategies"
          ],
      }
  ],
  content14:[
      {
          title: "Conclusion",
          content: "Dermatitis can significantly impact quality of life, but effective management is possible. At H-Cura, we provide natural solutions that address both symptoms and root causes.",
      },
      {
          title: "",
          content: "Our patient-centric approach helps achieve lasting relief while restoring skin health. Begin your journey to comfortable, rash-free skin today.",
      },
  ],
},
//vitiligo

{
  id: "vitiligo",
  name: "vitiligo",
  metadata: [
    {
    title: "Vitiligo Treatment | H-Cura Homeopathy",
    description: "Natural vitiligo treatment addressing pigmentation loss. Safe homeopathic solutions for white patches. Book consultation for personalized care.",
    keywords: "Vitiligo treatment, Homeopathy for white patches, Natural skin repigmentation, Leukoderma cure",
    canonicalUrl: "https://www.h-cura.com/treatments/vitiligo",
    favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
      { type: "heading", content: "Best Homeopathic Vitiligo Treatment" },
  ],
  content1: [
      {
          type: "image",
          src: vitiligo,
          alt: "vitiligo-image1",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "Vitiligo Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2: [
      { type: "heading", content: "Best Homeopathic Vitiligo Treatment" },
  ],
  content3: [
      {
          type: "heading",
          content: "Vitiligo: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Vitiligo",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: "Vitiligo is a chronic autoimmune condition characterized by loss of skin pigment cells (melanocytes), resulting in white patches on the skin. These depigmented areas commonly appear on the face, hands, and body folds. The condition can significantly impact self-esteem and quality of life, especially when visible areas are affected. Segmental vitiligo appears on one side of the body, while non-segmental vitiligo spreads symmetrically.",
          className: "treatmentprecautions",
      },
  ],
  content4: [
      {
        type: "list",
        content: "Causes of Vitiligo",
        className: "treatmentinfection1",
        items: [
          "Autoimmune Factors: Immune system attacks melanocytes",
          "Genetic Predisposition: Family history of vitiligo",
          "Neural Hypothesis: Nerve endings release toxic substances",
          "Oxidative Stress: Accumulation of free radicals",
          "Emotional Triggers: Stressful events triggering onset"
        ],
      },
      {
        type: "image-overlay",
        src: vitiligotreatment,
        alt: "Vitiligo Treatment Image",
        title: "Book an Appointment",
        description: "Natural solutions for skin repigmentation",
        link: "/bookconsultation",
        buttonText: "Book Appointment",
      }
  ],
  content5: [
      {
          type: "list",
          content: "Complications of Vitiligo",
          items: [
            "Social anxiety and depression",
            "Increased sunburn risk in depigmented areas",
            "Associated thyroid disorders",
            "Halo nevi development around moles"
          ],
      },
      {
          type: "list1",
          content: "Symptoms of Vitiligo",
          content1: "Vitiligo presents with various patterns and symptoms:",
          items: [
            "Milky-white patches with distinct borders",
            "Premature graying of hair/scalp hair",
            "Symmetrical patch distribution in non-segmental type",
            "Rapid spread during active phases"
          ],
      }
  ],
  content6: [
      {
        type: "paragraph",
        content: "Diagnosis of Vitiligo",
        content1: "At H-Cura Homeopathy, we use advanced diagnostic methods including Wood's lamp examination and detailed medical history analysis. Our three-step process includes: 1) Evaluating patch distribution patterns 2) Assessing autoimmune markers 3) Identifying triggering factors. This comprehensive approach helps determine the best treatment strategy for each case.",
        className: "treatmentDiagnosis"
      },
  ],
  content7: [
      { src: vitiligogallery1, alt: "vitiligo" },
      { src: vitiligogallery2, alt: "vitiligo" },
      { src: vitiligogallery3, alt: "vitiligo" },
      { src: vitiligogallery4, alt: "vitiligo" }
  ],
  content8: [
      {
          title1: "Homeopathic Treatment for Vitiligo at H-Cura",
          description1: "Our therapies focus on reactivating melanocyte function and stopping autoimmune destruction. Treatment helps achieve natural repigmentation through safe, non-invasive methods.",
      }
  ],
  content9: [
      {
          icon: <FaRegCircle className="feature-icon1" />,
          title: "Pigment Stimulation",
          description: "Activate dormant melanocytes"
      },
      {
          icon: <FaShieldAlt className="feature-icon1" />,
          title: "Immune Balance",
          description: "Correct autoimmune responses"
      },
      {
          icon: <FaSun className="feature-icon1" />,
          title: "Sun Protection",
          description: "Customized UV care plans"
      }
  ],
  content10: [
      {
          title: "Why Choose H-Cura Homeopathy for Vitiligo Treatment?",
      },
  ],
  content11: [
      {
          description: "Our treatment addresses both skin depigmentation and associated autoimmune factors",
      },
      {
          description: "15+ years experience in progressive repigmentation therapies",
      },
      {
          description: "Personalized plans based on patch distribution and progression speed",
      },
  ],
  content12: [
      {
          title: "Effective Vitiligo Management",
      },
  ],
  content13: [
      {
          type: "list",
          content: "Types of Vitiligo We Treat",
          items: [
            "Facial vitiligo: Specialized care for visible areas",
            "Segmental vitiligo: Unilateral patch management",
            "Mucosal vitiligo: Lip and genital area treatment",
            "Universal vitiligo: Whole-body depigmentation care"
          ],
      },
      {
          type: "list1",
          content: "Key Treatment Features",
          content1: "Our holistic approach combines internal remedies with topical applications:",
          items: [
            "Non-invasive repigmentation techniques",
            "Safe for sensitive skin areas",
            "Stress management protocols",
            "Dietary antioxidant plans"
          ],
      }
  ],
  content14: [
      {
          title: "Conclusion",
          content: "Vitiligo management requires a comprehensive approach addressing both physical and emotional aspects. At H-Cura Homeopathy Multispecialty Clinic, we offer advanced solutions that promote natural repigmentation and improve quality of life.",
      },
      {
          title: "",
          content: "Our patient-centric protocols help achieve visible results while preventing disease progression. Begin your journey to restored skin pigmentation today.",
      },
  ],
},
//Scabbies
{
  id: "scabies",
  name: "scabies",
  metadata: [
    {
    title: "Scabies Treatment | H-Cura Homeopathy",
    description: "Effective homeopathic treatment for scabies infestation. Relieve intense itching and prevent recurrence. Consult our skin experts today.",
    keywords: "Scabies treatment, Homeopathy for mites, Natural parasite treatment, Itch relief remedies",
    canonicalUrl: "https://www.h-cura.com/treatments/scabies",
    favicon: "/assets/images/favicon.ico"
    }
  ],
  content: [
      { type: "heading", content: "Best Homeopathic Scabies Treatment" },
  ],
  content1: [
      {
          type: "image",
          src: scabies,
          alt: "scabies-image1",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "Scabies Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2: [
      { type: "heading", content: "Best Homeopathic Scabies Treatment" },
  ],
  content3: [
      {
          type: "heading",
          content: "Scabies: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Scabies",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: "Scabies is a highly contagious skin infestation caused by Sarcoptes scabiei mites. These microscopic parasites burrow into the skin's upper layer, causing intense itching that worsens at night. The condition spreads rapidly through close physical contact and shared personal items. Norwegian scabies (crusted scabies) is a severe form seen in immunocompromised individuals, characterized by thick crusts containing thousands of mites.",
          className: "treatmentprecautions",
      },
  ],
  content4: [
      {
        type: "list",
        content: "Causes of Scabies",
        className: "treatmentinfection1",
        items: [
          "Parasitic Infestation: Sarcoptes scabiei mite transmission",
          "Direct Contact: Skin-to-skin contact with infected person",
          "Contaminated Objects: Sharing bedding/towels",
          "Crowded Environments: Nursing homes, prisons",
          "Weakened Immunity: Increased susceptibility"
        ],
      },
      {
        type: "image-overlay",
        src: scabiestreatment,
        alt: "Scabies Treatment Image",
        title: "Book an Appointment",
        description: "Complete mite eradication solutions",
        link: "/bookconsultation",
        buttonText: "Book Appointment",
      }
  ],
  content5: [
      {
          type: "list",
          content: "Complications of Scabies",
          items: [
            "Secondary bacterial infections from scratching",
            "Post-scabetic eczema lasting weeks after treatment",
            "Crusted scabies in elderly/immunocompromised",
            "Family outbreak requiring simultaneous treatment"
          ],
      },
      {
          type: "list1",
          content: "Symptoms of Scabies",
          content1: "Scabies presents with characteristic signs:",
          items: [
            "Intense itching worsening at night",
            "Thin burrow tracks (finger webs, wrists)",
            "Pimple-like rash in armpits/groin",
            "Small blisters in infants/elderly"
          ],
      }
  ],
  content6: [
      {
        type: "paragraph",
        content: "Diagnosis of Scabies",
        content1: "At H-Cura Homeopathy, we use a three-step diagnostic process: 1) Microscopic identification of mites from skin scrapings 2) Ink test visualization of burrows 3) Clinical history of contact/exposure. This helps confirm infestation and rule out similar conditions like eczema or psoriasis.",
        className: "treatmentDiagnosis"
      },
  ],
  content7: [
      { src: scabies1, alt: "scabies" },
      { src: scabies2, alt: "scabies" },
      { src: scabies3, alt: "scabies" },
      { src: scabies4, alt: "scabies" }
  ],
  content8: [
      {
          title1: "Homeopathic Treatment for Scabies at H-Cura",
          description1: "Our protocol combines antiparasitic remedies with skin-healing solutions. Treatment focuses on complete mite eradication while preventing family transmission.",
      }
  ],
  content9: [
      {
          icon: <FaBug className="feature-icon1" />,
          title: "Mite Elimination",
          description: "Natural acaricidal properties"
      },
      {
          icon: <FaSkullCrossbones className="feature-icon1" />,
          title: "Infection Control",
          description: "Prevent bacterial complications"
      },
      {
          icon: <FaShieldAlt className="feature-icon1" />,
          title: "Family Protection",
          description: "Household disinfection guidance"
      }
  ],
  content10: [
      {
          title: "Why Choose H-Cura Homeopathy for Scabies Treatment?",
      },
  ],
  content11: [
      {
          description: "24-48 hour itch relief without steroid creams",
      },
      {
          description: "Safe for pregnant women and infants",
      },
      {
          description: "Complete household treatment protocols",
      },
  ],
  content12: [
      {
          title: "Effective Scabies Management",
      },
  ],
  content13: [
      {
          type: "list",
          content: "Types We Treat",
          items: [
            "Classic scabies: Common mite infestation",
            "Crusted scabies: Severe hyperkeratotic form",
            "Nodular scabies: Post-treatment persistent nodes",
            "Infantile scabies: Gentle baby-safe solutions"
          ],
      },
      {
          type: "list1",
          content: "Treatment Features",
          content1: "Our comprehensive approach includes:",
          items: [
            "Non-toxic mite eradication",
            "Simultaneous family treatment",
            "Home disinfection checklist",
            "Post-treatment follow-ups"
          ],
      }
  ],
  content14: [
      {
          title: "Conclusion",
          content: "Scabies requires immediate treatment to prevent community spread. At H-Cura Homeopathy Multispecialty Clinic, we offer safe, natural solutions that effectively break the infestation cycle.",
      },
      {
          title: "",
          content: "Our protocols ensure complete eradication while protecting sensitive skin. Regain comfort and prevent recurrence with our expert care.",
      },
  ],
}





































// Add more diseases here
];